// Components
import TurnsModal from './TurnsModal'
import AddUserToScaleModal from '@/modals/AddUserToScaleModal'
import ConfirmScaleModal from './ConfirmScaleModal'
import ConfirmDialog from '@/modals/ConfirmDialog'
import SosButton from '@/components/SosButton'
import SosSelect from '@/components/SosSelect'
import SosEditShiftCard from './SosEditShiftCard'
/*
// [staging-portaltelemedicina / master-portaltelemedicina]
import ConsultationTypePicker from '@/modals/ConsultationTypePicker'
// [staging-portaltelemedicina / master-portaltelemedicina]
*/

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import { valueToDB, valueToTime } from '@/functions'
import { formatFloatToScaleDuration, durationToMinutes, formatDbTime, calculateEndTime } from '@/mixins/utils'
import scaleMixin from '@/mixins/scale.mixin.js'
import confirmDialogMixin from '@/mixins/cd.mixin.js'

import userProfileBroken from '@/assets/images/user-profile-broken.png'

import { mapState } from 'vuex'

import { apiServerTimestamp } from '@/services/index'
import { isValidDuty, createDutyObject, apiGetGroupDutyChatMessages, apiGetGroupShifts } from '@/services/duties'
import { apiGetCurrentUser, apiGenerateEntityID, fbFullUpdate, apiUpdateScaleName, apiGetGroupNewWeekChatMessages, createShift, getDutyById } from '@/services/firebase'
import { apiGetUserListByScale } from '@/services/endpoints/users'
import { apiUndoLastScaleDutiesChange } from '@/services/endpoints/scales'
import { VALIDATE_RULES_BATCH, DISPATCH_DUTIES } from '@/store/working-hours-rules/types'
import { durationHoursToMinutes, buildStartAtISO } from '@/functions/workingHours'

// constants
import { MINI_RELEASED_DUTIES_BUTTON_1, MINI_RELEASED_DUTIES_BUTTON_2 } from '@/constants/releasedDutiesButtonSources'
import { ESCALA_DISPARAR_PLANTOES, GRUPO_ACOMPANHAR_ESCALA } from '@/constants'
import { logDebug } from '@/functions/debug'
import { EditScaleUsersCache } from '@/composables/useStorage'

import moment from 'moment'
import 'moment/locale/pt-br'
moment.locale('pt-BR')

//
// Extrai snapshot de ponto (check-in/out) de um objeto de plantão do Firebase
// para ser gravado atomicamente no log de exclusão.
//
const extractPontoForLog = (duty) => {
  if (!duty || typeof duty !== 'object') return {}
  const ponto = {}

  const extractDeviceInfo = (device) => {
    if (!device || typeof device !== 'object') return ''
    const modelo  = device.model?.name ? String(device.model.name).trim() : ''
    const tipoMap = { '1': 'Celular ', '2': 'Tablet ', '3': 'TV ', '4': 'Desktop ' }
    const tipo    = tipoMap[String(device.type || '')] || ''
    const apelido = device.name ? String(device.name).trim() : 'Não encontrado'
    const osName  = device.os?.name  ? String(device.os.name).trim()  : ''
    const osVers  = device.os?.vers  ? String(device.os.vers).trim()  : ''
    const osBuild = device.os?.build ? String(device.os.build).trim() : ''
    let unico = ''
    if (osName === 'ios'     && device.unique?.ios)     unico = String(device.unique.ios)
    else if (osName === 'android' && device.unique?.android) unico = String(device.unique.android)
    else unico = device.unique?.push ? String(device.unique.push) : 'N/A'
    if (!modelo && unico === 'N/A' && !osName) return ''
    return `MODELO: ${tipo}${modelo} -> ID: ${unico} -> SISTEMA: ${osName} ${osVers} (Build: ${osBuild}) -> APELIDO: ${apelido}`
  }

  const startLoc = duty.start_location || null
  if (startLoc && typeof startLoc === 'object' && startLoc.timestamp) {
    const entry = { ts: startLoc.timestamp, origin: startLoc.origin || '' }
    if (startLoc.latitude)  entry.lat = startLoc.latitude
    if (startLoc.longitude) entry.lng = startLoc.longitude
    const did = extractDeviceInfo(startLoc.device)
    if (did) entry.deviceId = did
    ponto.pontoEntrada = entry
  }

  const endLoc = duty.end_location || null
  if (endLoc && typeof endLoc === 'object' && endLoc.timestamp) {
    const entry = { ts: endLoc.timestamp, origin: endLoc.origin || '' }
    if (endLoc.latitude)  entry.lat = endLoc.latitude
    if (endLoc.longitude) entry.lng = endLoc.longitude
    const did = extractDeviceInfo(endLoc.device)
    if (did) entry.deviceId = did
    const obs = (endLoc.observation || '').trim()
    if (obs) entry.obs = obs
    ponto.pontoSaida = entry
  }

  const obsGestor = (duty.observacao || '').trim()
  if (obsGestor) ponto.obsGestor = obsGestor

  return ponto
}

//
// Função para calcular o horário de término de um plantão
//

const calculateEndDateAndTime = (startDate, startTime, duration, withZero = false) => {
  const [startHour, startMinute] = String(startTime).split(':').map(Number)
  const [year, month, day] = String(startDate).split('-').map(Number)
  const [durationHours, durationMinutes] = String(duration).split(':').map(Number)

  // Convertendo a duração total para minutos
  const totalMinutes = startHour * 60 + startMinute + durationHours * 60 + durationMinutes
  const endHour = Math.floor(totalMinutes / 60) % 24
  const endMinute = totalMinutes % 60

  // Adicionando a data inicial para criar um objeto de data e hora
  const endDate = new Date(year, month - 1, day, endHour, endMinute)

  // Verificando se a data final é no dia seguinte
  if (totalMinutes >= 24 * 60) {
    endDate.setDate(endDate.getDate() + 1)
  }

  // Formatando a data final para o formato YYYY-M-D (withZero === false) ou YYYY-MM-DD (withZero === true)
  const endDateYear = endDate.getFullYear()
  const endDateMonth = withZero ? String(endDate.getMonth() + 1).padStart(2, '0') : endDate.getMonth() + 1
  const endDateDay = withZero ? String(endDate.getDate()).padStart(2, '0') : endDate.getDate()
  const endDateHour = String(endDate.getHours()).padStart(2, '0')
  const endDateMinute = String(endDate.getMinutes()).padStart(2, '0')

  return `${endDateYear}-${endDateMonth}-${endDateDay} ${endDateHour}:${endDateMinute}`
}

//
// TESTAR PASSAGEM DE ANO
//

const checkConflict = (plantao1, plantao2, intervalo = false/* , nome = 'Function Unknown' */) => {
  //
  const shiftStartDateAndTime = (new Date(plantao1.startDate + 'T' + plantao1.startTime + ':00.000Z')).getTime()

  // console.log(`::: [${nome}] shiftStartDateAndTime:`, plantao1.startDate + ' ' + plantao1.startTime)

  //
  let shiftEndDateAndTime = calculateEndDateAndTime(plantao1.startDate, plantao1.startTime, plantao1.duration, true).split(' ')
  // console.log(`::: [${nome}] shiftEndDateAndTime:`, shiftEndDateAndTime[0] + ' ' + shiftEndDateAndTime[1])
  shiftEndDateAndTime = (new Date(shiftEndDateAndTime[0] + 'T' + shiftEndDateAndTime[1] + ':00.000Z')).getTime()

  //
  const turnStartDateAndTime = (new Date(plantao2.startDate + 'T' + plantao2.startTime + ':00.000Z')).getTime()
  // console.log(`::: [${nome}] turnStartDateAndTime:`, plantao2.startDate + ' ' + plantao2.startTime)
  let turnEndDateAndTime = calculateEndDateAndTime(plantao2.startDate, plantao2.startTime, plantao2.duration, true).split(' ')
  // console.log(`::: [${nome}] turnEndDateAndTime:`, turnEndDateAndTime[0] + ' ' + turnEndDateAndTime[1])
  turnEndDateAndTime = (new Date(turnEndDateAndTime[0] + 'T' + turnEndDateAndTime[1] + ':00.000Z')).getTime()

  // Converte o intervalo de horas para milissegundos
  const intervaloMilissegundos = !!intervalo === false ? 0 : intervalo /* * 60 */ * 60 * 1000

  // INÍCIO DO PLANTÃO EXISTENTE ESTÁ DENTRO DO TURNO?
  // FIM DO PLANTÃO EXISTENTE ESTÁ DENTRO DO TURNO?

  // console.log(`::: [${nome}] checkConflict:`, intervalo)

  return !!intervalo === false ? (
    ((shiftStartDateAndTime > turnStartDateAndTime) && (shiftStartDateAndTime < turnEndDateAndTime)) ||
    ((shiftEndDateAndTime > turnStartDateAndTime) && (shiftEndDateAndTime < turnEndDateAndTime))
  ) : (
    ((shiftStartDateAndTime >= turnStartDateAndTime) && (shiftStartDateAndTime <= turnEndDateAndTime + intervaloMilissegundos)) ||
    ((shiftEndDateAndTime >= turnStartDateAndTime) && (shiftEndDateAndTime <= turnEndDateAndTime + intervaloMilissegundos))
  )
}

//
//
//

export default {
  name: 'EditScale',

  components: {
    TurnsModal,
    AddUserToScaleModal,
    ConfirmScaleModal,
    ConfirmDialog,
    'sos-select': SosSelect,
    'date-picker': DatePicker,
    'sos-button': SosButton,
    'sos-edit-shift-card': SosEditShiftCard,
    /*
    // [staging-portaltelemedicina / master-portaltelemedicina]
    'consultation-type-picker': ConsultationTypePicker,
    // [staging-portaltelemedicina / master-portaltelemedicina]
    */
  },

  mixins: [
    scaleMixin,
    confirmDialogMixin,
  ],

  data () {
    return {
      undoLoading: false,
      // loading: false,

      isHeaderFixed: false,
      showGoToTopButton: false,

      showScaleCurrentWeekHeader: false,

      showDeletedDuties: true,

      //
      // JOURNEY
      //

      jornada: 'Manual',

      journeyWorkingDays: '',
      journeyDaysOff: '',

      workingJourneys: [
        { key: 'jornada_manual', text: '<span class="journeyOption">Manual<br /><span class="journeyOptionObservation">Você escolhe o dia e turno</span></span>', value: 'Manual' },
        { key: 'jornada_semanal', text: '<span class="journeyOption">Semanal<br /><span class="journeyOptionObservation">Um plantão a cada 7 dias</span></span>', value: 'Semanal' },
        { key: 'jornada_12x36', text: '<span class="journeyOption">12x36<br /><span class="journeyOptionObservation">1 dia de trabalho e 1 de descanso</span></span>', value: '12x36' },
        { key: 'jornada_12x48', text: '<span class="journeyOption">24x48<br /><span class="journeyOptionObservation">1 dia de trabalho e 2 de descanso</span></span>', value: '12x48' },
        { key: 'jornada_12x72', text: '<span class="journeyOption">36x72<br /><span class="journeyOptionObservation">1 dia de trabalho e 3 de descanso</span></span>', value: '12x72' },
        { key: 'jornada_5x2', text: '<span class="journeyOption">5x2<br /><span class="journeyOptionObservation">5 dias de trabalho e 2 de descanso</span></span>', value: '5x2' },
        { key: 'jornada_6x1', text: '<span class="journeyOption">6x1<br /><span class="journeyOptionObservation">6 dias de trabalho e 1 de descanso</span></span>', value: '6x1' },
        { key: 'jornada_personalizada', text: '<span class="journeyOption">Personalizada<br /><span class="journeyOptionObservation">Você escolhe intervalo e sequência</span></span>', value: 'Personalizado' },
      ],

      //
      //
      //

      selectedDate: null,
      selectedWeek: null,
      selectedMiniWeekAnalysis: null,
      hasMiniReleasedOnWeekNode: {},

      loadingMessage: 'Carregando...',

      // Constantes para os botões mini disparar
      MINI_RELEASED_DUTIES_BUTTON_1: MINI_RELEASED_DUTIES_BUTTON_1,
      MINI_RELEASED_DUTIES_BUTTON_2: MINI_RELEASED_DUTIES_BUTTON_2,

      // --- User list for scale assignment
      pollingTimer: null,
      pollingRunning: false,
      // cachedUsersForScale: [],
      lastUsersUpdateAt: null,
    }
  },

  computed: {
    ...mapState({
      group: state => state.app.group,
      groupUsers: state => state.app.groupUsers,
      listeners: state => state.app.listeners,
      currentGroupCapabilities: state => state.app.currentGroupCapabilities,
    }),

    showScaleInfo () {
      return (
        this.scaleName.length > 0
        ||
        this.scaleLocation.name.trim().length > 0
        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        ||
        this.scaleConsultationDuration
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */
      )
    },

    permissaoEscalaDispararPlantoes () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_DISPARAR_PLANTOES] === true
    },

    permissaoGrupoAcompanharEscala () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[GRUPO_ACOMPANHAR_ESCALA] === true
    },

    loadingGroupUsers() {
      return this.listeners.loadingGroupUsers
    },

    nomeDoGrupo () {
      return !!this.group && !!this.group.nome ? this.group.nome : ''
    },

    permissaoDispararPlantoes () {
      return !!this.currentGroupCapabilities === true && !!this.currentGroupCapabilities[ESCALA_DISPARAR_PLANTOES] === true
    },

    // Texto dinâmico para o botão mini disparar
    getMiniReleasedBtnText() {
      return (weekID, miniReleasedButton) => {
        if (!this.weeks[weekID] && miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_1) return 'Dias do mês anterior'
        if (!this.weeks[weekID] && miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_2) return 'Dias do mês seguinte'

        const weekAnalysis = this.analyzeWeekMonths(this.weeks[weekID].value)
        const { previousMonthDays, nextMonthDays, currentMonthDays } = weekAnalysis

        if (previousMonthDays > 0 && miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_1) {
          return 'Disparar dias do mês anterior'
        } else if (nextMonthDays > 0 && miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_2) {
          return 'Disparar dias do mês seguinte'
        } else if (currentMonthDays > 0) {
          return 'Disparar dias do mês atual'
        } else {
          return 'Disparar dias do mês anterior'
        }
      }
    },

    // Texto dinâmico para o botão mini editar
    getMiniEditBtnText() {
      return (weekID, miniReleasedButton) => {
        if (!this.weeks[weekID] && miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_1) return 'Editar anterior'
        if (!this.weeks[weekID] && miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_2) return 'Editar seguinte'

        const weekAnalysis = this.analyzeWeekMonths(this.weeks[weekID].value)
        const { previousMonthDays, nextMonthDays, currentMonthDays } = weekAnalysis

        if (previousMonthDays > 0 && miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_1) {
          return 'Editar dias do mês anterior'
        } else if (nextMonthDays > 0 && miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_2) {
          return 'Editar dias do mês seguinte'
        } else if (currentMonthDays > 0) {
          return 'Editar dias do mês atual'
        } else {
          return 'Editar dias do mês anterior'
        }
      }
    },

    // Verifica se a semana tem dias de outros meses (mês anterior ou mês seguinte)
    hasOtherMonthDays() {
      return (weekID) => {
        if (!this.weeks[weekID]) return false

        const weekAnalysis = this.analyzeWeekMonths(this.weeks[weekID].value)
        const { previousMonthDays, nextMonthDays } = weekAnalysis

        // Só mostra os botões mini se há dias de outros meses
        return previousMonthDays > 0 || nextMonthDays > 0
      }
    },

    // Verifica se o botão MINI_RELEASED_DUTIES_BUTTON_1 ou MINI_RELEASED_DUTIES_BUTTON_2 deve estar habilitado
    isMiniReleasedBtnEnabled() {
      return (weekID, miniReleasedButton) => {
        if (!this.weeks[weekID]) return false

        // Primeiro verifica se a semana tem dias de outros meses
        if (!this.hasOtherMonthDays(weekID)) return false

        const weekAnalysis = this.analyzeWeekMonths(this.weeks[weekID].value)
        const miniReleasedType = this.determineMiniReleasedType(
          weekAnalysis,
          miniReleasedButton,
          this.actualMonth,
          this.actualYear
        )

        if (!miniReleasedType) return false

        // Verifica se há plantões para o tipo de disparo determinado
        return this.weekHasScale(this.weeks[weekID], miniReleasedType)
      }
    },

    // Verifica se já tem um mini botão que foi disparado
    isMiniReleasedBtn() {
      return (firstDayOfWeek, miniReleasedButton) => {
        if (this.scaleTurns.length === 0) return false

        // Verifica se a semana tem miniReleased usando o índice
        if (this.hasMiniReleasedOnWeekNode[firstDayOfWeek]) {
          // Verifica se o botão específico foi usado
          const weekAnalysis = this.selectedMiniWeekAnalysis[firstDayOfWeek]
          if (weekAnalysis && weekAnalysis.miniReleased && weekAnalysis.miniReleased.button === miniReleasedButton) {
            return true
          }
        }

        // Fallback: verifica diretamente nos plantões se não encontrou no índice
        const week = this.weeks.find(w => w.firstDayOfWeek === firstDayOfWeek)
        if (!week || !week.value) return false

        return week.value.some(day => {
          const dayFmtWzero = day.dayFmtWzero
          return this.scaleTurns.some(turn => {
            const diaComUsuarios = turn.plantoes && turn.plantoes[dayFmtWzero]
            return diaComUsuarios &&
                   diaComUsuarios.confirmedDutys === true &&
                   diaComUsuarios.miniReleased &&
                   diaComUsuarios.miniReleased.released === true &&
                   diaComUsuarios.miniReleased.button === miniReleasedButton
          })
        })
      }
    },

    // Verifica se o botão de adicionar usuário deve estar roxo ou azull
    isMiniOrWeekReleased () {
      return (week, day) => {
        // console.log('isMiniOrWeekReleased:', week, day)
        if (this.scaleTurns.length === 0) return false

        const weekAnalysis = this.getSelectedMiniWeekAnalysis(week)
        return weekAnalysis && weekAnalysis.miniReleased ? this.isMiniReleased(day) : this.isWeekReleased(week)
      }
    },

    // Verifica se já existe um mini disparado em uma semana específica
    hasMiniReleasedOnWeek() {
      return (week) => {
        if (this.scaleTurns.length === 0) return false

        // Verifica se a semana tem miniReleased usando o índice
        if (this.hasMiniReleasedOnWeekNode[week.firstDayOfWeek]) {
          return true
        }

        // Fallback: verifica diretamente nos plantões se não encontrou no índice
        return week.value.some(day => {
          const dayFmtWzero = day.dayFmtWzero
          return this.scaleTurns.some(turn => {
            const diaComUsuarios = turn.plantoes && turn.plantoes[dayFmtWzero]
            return diaComUsuarios &&
                   diaComUsuarios.confirmedDutys === true &&
                   diaComUsuarios.miniReleased &&
                   diaComUsuarios.miniReleased.released === true
          })
        })
      }
    },
  },

  watch: {
    weeks: {
      handler (newVal, oldVal) {
        this.$store.commit('SET_WEEKS', this.weeks)
      },
    },

    //
    // START ON MONDAY será atualizado quando A ESCALA É CARREGADA (confirmar IMMEDIATE?)
    //

    startOnMonday: {
      handler (newVal, oldVal) {
        if (oldVal === 'waiting' && newVal !== 'waiting') {
          // [24/01/25] console.log('::: EditScale > startOnMonday:', newVal)

          //
          // CACHED FILTERS
          //

          let parsedFilters = null

          const filters = localStorage.getItem(`@sosplantao_editscale_${this.$route.params.scaleID}`)

          if (!!filters === true) {
            try {
              parsedFilters = JSON.parse(filters)
            } catch (e) {
              localStorage.removeItem(`@sosplantao_editscale_${this.$route.params.scaleID}`)
            }
          }

          if (!!parsedFilters === true) this.scaleZoom = parsedFilters.zoom

          // CONSTRÓI O CALENDÁRIO APÓS RECONHECER QUAL O PRIMEIRO DIA DA SEMANA ESCOLHIDO PELOS GESTORES
          this.setYearMonthSetup(!!parsedFilters === true ? { month: parsedFilters.month, year: parsedFilters.year } : false)

          // GO TO WEEK
          // console.log('::: EditScale => GO TO WEEK => firstDayOfCurrentWeek:', this.firstDayOfCurrentWeek)

          /* this.$nextTick(() => {
            if (!!this.firstDayOfCurrentWeek === true) {
              this.goToCurrentWeek(`${this.firstDayOfCurrentWeek}`)
            }
          }) */
        }
      },
    },

    scaleTurns: {
      handler (newVal, oldVal) {
        // Quando os turnos são carregados e as semanas também estão disponíveis
        if (newVal && newVal.length > 0 && this.weeks && this.weeks.length > 0) {
          // console.log('Scale turns and weeks loaded, detecting mini released duties...')
          this.detectMiniReleasedDuties()
        }
      },
      immediate: false
    },
  },

  async mounted ()
  {
    const { groupID, scaleID } = this.$route.params

    // 🔹 1) tenta hidratar do cache
    const cached = EditScaleUsersCache.get(groupID, scaleID)

    if (cached?.users?.length)
    {
      // this.cachedUsersForScale = cached.users

      // Isso faz com que o LOADER do EditScale não fique esperando o "POLLING da lista de usuários da escala" terminar o
      // carregamento dos usuários para liberar a tela para o gestor trabalhar
      this.lastUsersUpdateAt = cached.lastModified

      logDebug({
        box: `Usuários da escala "${this.scaleName || this.$route.params.scaleID}"`,
        boxColor: 'lightgreen',
        title: 'Loaded from cache',
        titleColor: '#2E7D32',
        message: `${cached.users.length} users`,
      })
    }

    // 🔹 2) inicia polling normalmente (background)
    // 🔁 START POLLING AQUI
    this.START_SCALE_USER_LIST_POLLING()

    // LOAD SCALE
    this.loadScale(groupID, scaleID)

    // GO TO WEEK

    // APÓS ATUALIZAR A PÁGINA (Exemplo: F5) OS DETALHES DO GRUPO (E USUÁRIOS) SERÃO CARREGADOS.
    // ELES SÃO USADOS NA TELA AddUserToScaleModal
    this.$store.dispatch('loadGroupPage', groupID)

    // Carregar todos os usuários do grupo via Firebase
    // Usado para o getDutyImage pegar imagem, pensar em algo que faz buscar somente usuários do mês
    // Mudar estado localmente e gravar no banco
    await this.$store.dispatch('loadGroupUsersAll', groupID)

    this.localGroupID = groupID
    this.localScaleID = scaleID

    window.addEventListener('scroll', this.handleScroll) // SCROLL
    window.addEventListener('keydown', this.handleKeydown) // UNDO

    // [24/01/25] console.log('::: EditScale => mounted:', groupID, scaleID)
  },

  beforeDestroy () {
    // [24/01/25] console.log('::: EditScale => beforeDestroy')

    this.STOP_SCALE_USER_LIST_POLLING()

    window.removeEventListener('scroll', this.handleScroll) // SCROLL
    window.removeEventListener('keydown', this.handleKeydown) // UNDO

    // APLICA JORNADA MANUAL
    this.$store.commit('SET_WORKINGDAY', 'Manual')

    // LIMPA O CTRL+Z (apenas visualmente, não no banco de dados)
    this.$store.commit('CLEAR_EDIT_SCALE_CTRL_Z')
  },

  destroyed () {
    // [24/01/25] console.log('::: EditScale => destroyed')

    this.unloadScale()
  },

  methods: {
    /**
     * Retorna o nome do período baseado na hora
     * @param {string} hourStr - Hora no formato HH:MM
     * @returns {string} 'night' ou 'day'
     */
    getPeriodName(hourStr) {
      const hour = parseInt(hourStr.split(':')[0])
      console.log('::: getPeriodName => hour:', hour)
      return hour >= 17 ? 'night' : 'day'
    },

    /**
     * Retorna o tipo de semana baseado na data
     * @param {string} dateStr - Data no formato YYYY-MM-DD
     * @returns {string} 'weekend' ou 'weekdays'
     */
    getTypeWeek(dateStr) {
      const dayOfWeek = moment(dateStr).day()
      return (dayOfWeek === 0 || dayOfWeek === 6) ? 'weekend' : 'weekdays'
    },

    /**
     * Busca a primeira regra válida baseada na hierarquia de prioridade
     * @param {object} props - { rules, period, typeWeek }
     * @returns {number|null} Valor da regra encontrada ou null
     */
    findRuleByPriorityHierarchy(props) {
      const { rules, period, typeWeek } = props

      if (!rules || typeof rules !== 'object') return null

      // Verifica regra específica (ex: weekdays_night, weekend_day)
      const specificKey = `${typeWeek}_${period}`
      if (rules[specificKey] && rules[specificKey].value > 0) {
        return rules[specificKey].value
      }

      // Verifica regra geral do período (ex: night, day)
      if (rules[period] && rules[period].value > 0) {
        return rules[period].value
      }

      return null
    },

    /**
     * Calcula o valor do plantão seguindo a hierarquia de precificação
     * @param {string} userID - ID do usuário
     * @param {string} dateStr - Data no formato YYYY-MM-DD
     * @param {string} timeStr - Hora no formato HH:MM
     * @param {string} durationStr - Duração no formato HH:MM
     * @param {number} turnFixedValue - Valor fixo do turno
     * @returns {number} Valor calculado do plantão
     */
    calculateAutomaticDutyValue(userID, dateStr, timeStr, durationStr, turnFixedValue) {
      // Prioridade 1: Valor fixo do turno
      if (turnFixedValue > 0) {
        return turnFixedValue
      }

      // Busca dados do usuário
      const userData = this.scaleUsers && this.scaleUsers[userID] ? this.scaleUsers[userID] : null

      // Dados da escala como fallback
      const scaleData = {
        weekdaysHourlyRate: this.scaleWeekdaysHourlyRate,
        weekendHourlyRate: this.scaleWeekendHourlyRate,
        dayShiftHourlyRate: this.scaleDayShiftHourlyRate,
        nightShiftHourlyRate: this.scaleNightShiftHourlyRate,
        weekdaysDayShiftHourlyRate: this.scaleWeekdaysDayShiftHourlyRate,
        weekdaysNightShiftHourlyRate: this.scaleWeekdaysNightShiftHourlyRate,
        weekendDayShiftHourlyRate: this.scaleWeekendDayShiftHourlyRate,
        weekendNightShiftHourlyRate: this.scaleWeekendNightShiftHourlyRate,
        hourlyrate: this.scaleValue,
      }


      if (!userData && !scaleData.hourlyrate && !scaleData.weekdaysHourlyRate && !scaleData.weekendHourlyRate) return 0

      const typeWeek = this.getTypeWeek(dateStr)
      const periodName = this.getPeriodName(timeStr)


      // Duração do plantão em minutos
      const totalMinutes = durationToMinutes(durationStr)

      let hourlyRate = 0

      // Hierarquia de busca de valor
      if (userData) {
        if (typeWeek === 'weekdays') {
          // Prioridade 2: Noturno de dias de semana
          hourlyRate = this.findRuleByPriorityHierarchy({
            rules: userData.weekdaysNight || {},
            period: 'night',
            typeWeek: 'weekdays'
          })

          // Prioridade 3: Diurno de dias de semana
          if (!hourlyRate) {
            hourlyRate = this.findRuleByPriorityHierarchy({
              rules: userData.weekdaysDay || {},
              period: 'day',
              typeWeek: 'weekdays'
            })
          }

          // Prioridade 4: Geral de dias de semana
          if (!hourlyRate && userData.weekdaysGeneral && userData.weekdaysGeneral.value > 0) {
            hourlyRate = userData.weekdaysGeneral.value
          }
        } else if (typeWeek === 'weekend') {
          // Prioridade 2: Noturno de final de semana
          hourlyRate = this.findRuleByPriorityHierarchy({
            rules: userData.weekendNight || {},
            period: 'night',
            typeWeek: 'weekend'
          })

          // Prioridade 3: Diurno de final de semana
          if (!hourlyRate) {
            hourlyRate = this.findRuleByPriorityHierarchy({
              rules: userData.weekendDay || {},
              period: 'day',
              typeWeek: 'weekend'
            })
          }

          // Prioridade 4: Geral de final de semana
          if (!hourlyRate && userData.weekendGeneral && userData.weekendGeneral.value > 0) {
            hourlyRate = userData.weekendGeneral.value
          }
        }
      }

      // Fallback: Tenta valores gerais (noturno > diurno > base)
      if (!hourlyRate) {
        // Prioridade 5: Noturno geral do usuário
        if (userData && periodName === 'night' && userData.nightGeneral && userData.nightGeneral.value > 0) {
          hourlyRate = userData.nightGeneral.value
        }
        // Prioridade 6: Diurno geral do usuário
        else if (userData && periodName === 'day' && userData.dayGeneral && userData.dayGeneral.value > 0) {
          hourlyRate = userData.dayGeneral.value
        }
        // Prioridade 7: Estrutura ATUAL do usuário - weekendDayShiftHourlyRate / weekendNightShiftHourlyRate
        else if (userData && typeWeek === 'weekend' && periodName === 'day' && userData.weekendDayShiftHourlyRate && userData.weekendDayShiftHourlyRate > 0) {
          hourlyRate = userData.weekendDayShiftHourlyRate
        }
        else if (userData && typeWeek === 'weekend' && periodName === 'night' && userData.weekendNightShiftHourlyRate && userData.weekendNightShiftHourlyRate > 0) {
          hourlyRate = userData.weekendNightShiftHourlyRate
        }
        else if (userData && typeWeek === 'weekdays' && periodName === 'day' && userData.weekdaysDayShiftHourlyRate && userData.weekdaysDayShiftHourlyRate > 0) {
          hourlyRate = userData.weekdaysDayShiftHourlyRate
        }
        else if (userData && typeWeek === 'weekdays' && periodName === 'night' && userData.weekdaysNightShiftHourlyRate && userData.weekdaysNightShiftHourlyRate > 0) {
          hourlyRate = userData.weekdaysNightShiftHourlyRate
        }
        // Prioridade 8: Estrutura ANTIGA/SIMPLES do usuário - weekendHourlyRate / weekdaysHourlyRate
        else if (userData && typeWeek === 'weekend' && userData.weekendHourlyRate && userData.weekendHourlyRate > 0) {
          hourlyRate = userData.weekendHourlyRate
        }
        else if (userData && typeWeek === 'weekdays' && userData.weekdaysHourlyRate && userData.weekdaysHourlyRate > 0) {
          hourlyRate = userData.weekdaysHourlyRate
        }
        // Prioridade 9: Valor base do usuário (hourlyrate)
        else if (userData && userData.hourlyrate && userData.hourlyrate > 0) {
          hourlyRate = userData.hourlyrate
        }
        // Prioridade 10: Valores da escala (estrutura ATUAL - weekendDayShiftHourlyRate / weekendNightShiftHourlyRate)
        else if (typeWeek === 'weekend' && periodName === 'day' && scaleData.weekendDayShiftHourlyRate && scaleData.weekendDayShiftHourlyRate > 0) {
          hourlyRate = scaleData.weekendDayShiftHourlyRate
        }
        else if (typeWeek === 'weekend' && periodName === 'night' && scaleData.weekendNightShiftHourlyRate && scaleData.weekendNightShiftHourlyRate > 0) {
          hourlyRate = scaleData.weekendNightShiftHourlyRate
        }
        else if (typeWeek === 'weekdays' && periodName === 'day' && scaleData.weekdaysDayShiftHourlyRate && scaleData.weekdaysDayShiftHourlyRate > 0) {
          hourlyRate = scaleData.weekdaysDayShiftHourlyRate
        }
        else if (typeWeek === 'weekdays' && periodName === 'night' && scaleData.weekdaysNightShiftHourlyRate && scaleData.weekdaysNightShiftHourlyRate > 0) {
          hourlyRate = scaleData.weekdaysNightShiftHourlyRate
        }
        // Prioridade 11: Valores da escala (estrutura ANTIGA/SIMPLES - weekendHourlyRate / weekdaysHourlyRate)
        else if (typeWeek === 'weekend' && scaleData.weekendHourlyRate && scaleData.weekendHourlyRate > 0) {
          hourlyRate = scaleData.weekendHourlyRate
        }
        else if (typeWeek === 'weekdays' && scaleData.weekdaysHourlyRate && scaleData.weekdaysHourlyRate > 0) {
          hourlyRate = scaleData.weekdaysHourlyRate
        }
        // Prioridade 12: Valor base da escala (hourlyrate)
        else if (scaleData.hourlyrate && scaleData.hourlyrate > 0) {
          hourlyRate = scaleData.hourlyrate
        }
      }


      // Calcula o valor proporcional
      if (hourlyRate > 0) {
        const newDutyValue = (totalMinutes / 60) * hourlyRate
        return parseFloat(newDutyValue.toFixed(2))
      }

      return 0
    },

    toggleHeaderFixed() {
      this.isHeaderFixed = !this.isHeaderFixed;
    },

    toggleShowDeletedDuties() {
      this.showDeletedDuties = !this.showDeletedDuties;
    },
    setYearMonthWeek (date, type)
    {
      if (date !== null)
      {
        const monthYear = date.split('/')

        const month = monthYear[0]
        const year = Number(monthYear[1])

        // [24/01/25] console.log('::: EDIT SCALE:', date, type)

        this.generateWeeksInMonth(year, month, 'weeks')

        //
        // CACHE
        //

        localStorage.setItem(`@sosplantao_editscale_${this.$route.params.scaleID}`, JSON.stringify({ month, year, zoom: this.scaleZoom }))
      }
    },

    setZoom (zoom) {
      this.scaleZoom = zoom

      //
      // CACHE
      //

      localStorage.setItem(`@sosplantao_editscale_${this.$route.params.scaleID}`, JSON.stringify({ month: this.actualMonth, year: this.actualYear, zoom }))
    },

    onJourneyDaysOffChange (inputText) {
      let journeyDaysOff = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
      journeyDaysOff = journeyDaysOff.length > 0 ? (Number(journeyDaysOff) > 31 ? '' : journeyDaysOff) : ''

      this.journeyDaysOff = journeyDaysOff

      this.$store.commit('SET_DAYSOFFAMOUNT', journeyDaysOff)
    },

    onJourneyWorkingDaysChange (inputText) {
      let journeyWorkingDays = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
      journeyWorkingDays = journeyWorkingDays.length > 0 ? (Number(journeyWorkingDays) > 31 ? '' : journeyWorkingDays) : ''

      this.journeyWorkingDays = journeyWorkingDays

      this.$store.commit('SET_WORKINGDAYSAMOUNT', journeyWorkingDays)
    },

    resetJourney () {
      this.setJornada('Manual')
    },

    /**
     *
     * VERIFICA SE O PLANTÃO PODE SER COLOCADO NO TURNO
     * > SE SIM, ADICIONA NA ESCALA/PLANTÕES
     * > CASO CONTRÁRIO, MOSTRA UM ERRO/AVISO NA TELA
     *
     */

    ADD_AVAILABLE_DUTY (turnID, turn, selectedDate)
    {
      // --- /

      const { jornada, journeyWorkingDays, journeyDaysOff } = this.$store.state.app.EditScale

      if (
        jornada === 'Personalizado' &&
        (
          Number(journeyWorkingDays) <= 0 || Number(journeyWorkingDays) > 31 ||
          Number(journeyDaysOff) <= 0 || Number(journeyDaysOff) > 31
        )
      )
      {
        return this.showMessage('Atenção!', 'Você não terminou de personalizar a jornada!<br/ ><br />Desfaça a personalização ou informe quantos dias seguidos você quer inserir plantões (número de 1 a 31) e quantos dias de descanso.<br /><br />Depois tente incluir um novo plantão.')
      }

      // --- /

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      // const cdur = await apiGetScaleConsultationDuration(this.$route.params.groupID, this.$route.params.scaleID)

      if (![6, 10, 15, 20, 30, 60].includes(this.scaleConsultationDuration))
      {
        return this.showMessage('Atenção!', 'Defina um tempo de consulta na escala onde o plantão será inserido')
      }
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      // --- /

      // console.log('::: ADD AVAILABLE DUTY:', turnID, turn, selectedDate)

      const payload = { turnID, turn, selectedDate }

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      if (this.isWeekReleasedByShiftDate(turn, selectedDate)) {
        this.$refs.consultationTypeModal.open("add-available-duty", payload)
      } else {
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */
        this.onConsultationTypeModalClose({
          status: "STRAIGHT",
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          slotType: "FREE",
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
          event: "add-available-duty",
          payload
        })
      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      }
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */
    },

    //
    //
    //

    /* https://stackoverflow.com/questions/60380315/stick-date-to-the-top-until-a-new-dates-appears-during-scroll-like-in-whatsapp */

    handleScroll (event) {
      //
      //

      if (window.scrollY >= 300 && !this.showGoToTopButton) {
        // [24/01/25] console.log('SHOW GO TO TOP BUTTON')
        this.showGoToTopButton = true
      }

      if (window.scrollY < 300 && this.showGoToTopButton) {
        // [24/01/25] console.log('REMOVE GO TO TOP BUTTON')
        this.showGoToTopButton = false
      }

      //
      //
      //

      if (document.body.clientWidth <= 699 || this.scaleZoom !== '1')
      {
        if (this.showScaleCurrentWeekHeader === true) {
          this.showScaleCurrentWeekHeader = false

          // MOSTRAR
          const scaleBar = document.getElementById('scaleBar')
          if (scaleBar && scaleBar.classList) {
            scaleBar.classList.remove('scaleCalendarCurrentWeekWrapper--show')
          }
        }
      }
      else
      {
        const weekOne = document.getElementById('busstop_morning_0')
        const weekOneTop = weekOne ? weekOne.getBoundingClientRect().top : false

        const weekTwo = document.getElementById('busstop_morning_1')
        const weekTwoTop = weekTwo ? weekTwo.getBoundingClientRect().top : false

        const weekThree = document.getElementById('busstop_morning_2')
        const weekThreeTop = weekThree ? weekThree.getBoundingClientRect().top : false

        const weekFour = document.getElementById('busstop_morning_3')
        const weekFourTop = weekFour ? weekFour.getBoundingClientRect().top : false

        const weekFive = document.getElementById('busstop_morning_4')
        const weekFiveTop = weekFive ? weekFive.getBoundingClientRect().top : false

        const weekSix = document.getElementById('busstop_morning_5')
        const weekSixTop = weekSix ? weekSix.getBoundingClientRect().top : false

        const scrolledWeekOne = weekOneTop ? (weekOneTop <= 20 /* -60 */) : false // 170
        const scrolledWeekTwo = weekTwoTop ? (weekTwoTop <= 20 /* -60 */) : false // 170
        const scrolledWeekThree = weekThreeTop ? (weekThreeTop <= 20 /* -60 */) : false // 170
        const scrolledWeekFour = weekFourTop ? (weekFourTop <= 20 /* -60 */) : false // 170
        const scrolledWeekFive = weekFiveTop ? (weekFiveTop <= 20 /* -60 */) : false // 170
        const scrolledWeekSix = weekSixTop ? (weekSixTop <= 20 /* -60 */) : false // 170

        // console.log(`Week 1[${weekOneTop}]: ${scrolledWeekOne} / Week 2[${weekTwoTop}]: ${scrolledWeekTwo} / Week 3[${weekThreeTop}]: ${scrolledWeekThree} / Week 4[${weekFourTop}]: ${scrolledWeekFour} / Week 5[${weekFiveTop}]: ${scrolledWeekFive} / Week 6[${weekSixTop}]: ${scrolledWeekSix}`)

        //
        // EXIBIR BARRA

        const scaleBar = document.getElementById('scaleBar')

        if (scrolledWeekOne === true /* top >= 460 */ && this.showScaleCurrentWeekHeader === false) {
          this.showScaleCurrentWeekHeader = true

          if (scaleBar && scaleBar.classList) {
            scaleBar.classList.add('scaleCalendarCurrentWeekWrapper--show')
          }
        }

        if (scrolledWeekOne === false /* top < 460 */ && this.showScaleCurrentWeekHeader === true) {
          this.showScaleCurrentWeekHeader = false

          if (scaleBar && scaleBar.classList) {
            scaleBar.classList.remove('scaleCalendarCurrentWeekWrapper--show')
          }
        }

        //
        // IDENTIFICAR SEMANA ATUAL

        let currentWeekID = false

        if (scrolledWeekOne === true && scrolledWeekTwo === false) {
          currentWeekID = 0
        } else if (scrolledWeekTwo === true && scrolledWeekThree === false) {
          currentWeekID = 1
        } else if (scrolledWeekThree === true && scrolledWeekFour === false) {
          currentWeekID = 2
        } else if (scrolledWeekFour === true && scrolledWeekFive === false) {
          currentWeekID = 3
        } else if (scrolledWeekFive === true && scrolledWeekSix === false) {
          currentWeekID = 4
        } else if (scrolledWeekSix) {
          currentWeekID = 5
        }

        //
        // APLICAR OS DIAS (DA SEMANA ATUAL) DENTRO DA BARRA

        if (currentWeekID !== false) {
          /* document.getElementById(`currentWeekDay_${currentWeekID}_0`).innerHTML = */

          const $currentWeekDayOne = document.getElementById('currentWeekDayOne')
          if ($currentWeekDayOne) {
            $currentWeekDayOne.innerHTML = this.weeks[currentWeekID].value[0].day.format('ddd - DD/MM')
          }
          const $currentWeekDayTwo = document.getElementById('currentWeekDayTwo')
          if ($currentWeekDayTwo) {
            $currentWeekDayTwo.innerHTML = this.weeks[currentWeekID].value[1].day.format('ddd - DD/MM')
          }
          const $currentWeekDayThree = document.getElementById('currentWeekDayThree')
          if ($currentWeekDayThree) {
            $currentWeekDayThree.innerHTML = this.weeks[currentWeekID].value[2].day.format('ddd - DD/MM')
          }
          const $currentWeekDayFour = document.getElementById('currentWeekDayFour')
          if ($currentWeekDayFour) {
            $currentWeekDayFour.innerHTML = this.weeks[currentWeekID].value[3].day.format('ddd - DD/MM')
          }
          const $currentWeekDayFive = document.getElementById('currentWeekDayFive')
          if ($currentWeekDayFive) {
            $currentWeekDayFive.innerHTML = this.weeks[currentWeekID].value[4].day.format('ddd - DD/MM')
          }
          const $currentWeekDaySix = document.getElementById('currentWeekDaySix')
          if ($currentWeekDaySix) {
            $currentWeekDaySix.innerHTML = this.weeks[currentWeekID].value[5].day.format('ddd - DD/MM')
          }
          const $currentWeekDaySeven = document.getElementById('currentWeekDaySeven')
          if ($currentWeekDaySeven) {
            $currentWeekDaySeven.innerHTML = this.weeks[currentWeekID].value[6].day.format('ddd - DD/MM')
          }
        }
      }
    },

    toTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    //
    //
    //

    openTurnsModal: function ()
    {
      this.$refs.turnsModal.open({
        mes: this.actualMonth,
        ano: this.actualYear,
        groupID: this.localGroupID,
        scaleID: this.localScaleID,
        turns: this.scaleTurns,
      })
    },

    goToViewScale () {
      this.$router.push(`/admin/grupos/${this.localGroupID}/escalas/${this.localScaleID}`)
    },

    goBackToGroupScales () {
      this.$router.push(`/admin/grupos/${this.localGroupID}/escalas`)
    },

    openConfirmScaleModal (weekID)
    {
      if (!this.permissaoEscalaDispararPlantoes) {
        return this.showMessage('Atenção!', 'Você não tem permissão para disparar plantões nesta escala.')
      }

      // possibilidade de verificar aqui se há plantões na semana antes de permitir modal
      this.selectedWeek = this.weeks[weekID]
      this.selectedMiniWeekAnalysis = {}

      this.onConsultationTypeModalClose({
        status: "STRAIGHT",
        event: "confirm-scale",
        payload: null
      })
    },

    // Determina o tipo de disparo mini baseado na semana e no tipo de botão
    determineMiniReleasedType(weekAnalysis, miniReleasedButton, currentMonth, currentYear) {
      const { previousMonthDays, currentMonthDays, nextMonthDays } = weekAnalysis

      if (miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_1) {
        // MINI_RELEASED_DUTIES_BUTTON_1: Disparar Dias do mês anterior OU Dias do mês atual
        if (previousMonthDays > 0) {
          // Se há dias do Dias do mês anterior, dispara o Dias do mês anterior
          return 'previous'
        } else if (currentMonthDays > 0) {
          // Se não há dias do Dias do mês anterior mas há do Dias do mês atual, dispara o Dias do mês atual
          return 'current'
        }
      } else if (miniReleasedButton === MINI_RELEASED_DUTIES_BUTTON_2) {
        // Mini2: Disparar Dias do mês atual OU Dias do mês seguinte
        if (nextMonthDays > 0) {
          // Se há dias do Dias do mês seguinte, dispara o Dias do mês seguinte
          return 'next'
        } else if (currentMonthDays > 0) {
          // Se não há dias do Dias do mês seguinte mas há do Dias do mês atual, dispara o Dias do mês atual
          return 'current'
        }
      }

      return null
    },

    openMiniReleasedModal (weekID, miniReleasedButton) {
      if (!this.permissaoEscalaDispararPlantoes) {
        this.showMessage('Atenção!', 'Você não tem permissão para disparar plantões nesta escala.')
        return false
      }

      // Serve para recalcular o X de cada dia da semana, dependendo do mini clicado
      this.selectedMiniWeekAnalysis = {}

      const week = this.weeks[weekID]

      // Verifica se já existe um mini disparado nesta semana usando o computed
      const hasMiniReleasedOnWeek = this.hasMiniReleasedOnWeek(week)

      // Define a semana selecionada para o modal
      this.selectedWeek = week

      // Se já existe um mini disparado, dispara a semana toda usando o modal padrão
      if (hasMiniReleasedOnWeek) {
        this.openConfirmScaleModal(weekID)
        return
      }


      // Analisa a semana para determinar o tipo de disparo
      const weekAnalysis = this.analyzeWeekMonths(week.value)

      // Determina o tipo de disparo baseado no botão e na análise da semana
      const miniReleasedType = this.determineMiniReleasedType(
        weekAnalysis,
        miniReleasedButton,
        this.actualMonth,
        this.actualYear
      )

      // Define o selectedMiniWeekAnalysis com as informações do mini dispatch usando o índice da semana
      if (miniReleasedType) {
        this.selectedMiniWeekAnalysis[week.firstDayOfWeek] = {
          ...weekAnalysis,
          miniReleased: {
            released: true,
            type: miniReleasedType,
            button: miniReleasedButton
          },
          weekIndex: weekID,
          firstDayOfWeek: week.firstDayOfWeek
        }
      }

      // Abre o modal de confirmação
      this.$refs.csModal.open()
    },

    analyzeWeekMonths (weekDays) {
      if (!weekDays || !Array.isArray(weekDays) || weekDays.length === 0) {
        return {
          previousMonthDays: 0,
          currentMonthDays: 0,
          nextMonthDays: 0,
          previousMonthDates: [],
          currentMonthDates: [],
          nextMonthDates: []
        }
      }

      const currentMonth = this.actualMonth
      const currentYear = this.actualYear

      let previousMonthDays = 0
      let currentMonthDays = 0
      let nextMonthDays = 0

      const previousMonthDates = []
      const currentMonthDates = []
      const nextMonthDates = []

      weekDays.forEach(day => {
        if (!day || !day.day) return

        const dayMonth = day.day.get('month')
        const dayYear = day.day.get('year')
        const dayDate = day.day.format('YYYY-MM-DD')

        // Verificar se é Dias do mês anterior
        if (dayYear < currentYear || (dayYear === currentYear && dayMonth < currentMonth)) {
          previousMonthDays++
          previousMonthDates.push(day)
        }
        // Verificar se é Dias do mês atual
        else if (dayYear === currentYear && dayMonth === currentMonth) {
          currentMonthDays++
          currentMonthDates.push(day)
        }
        // Verificar se é Dias do mês seguinte
        else if (dayYear > currentYear || (dayYear === currentYear && dayMonth > currentMonth)) {
          nextMonthDays++
          nextMonthDates.push(day)
        }
      })

      const result = {
        previousMonthDays,
        currentMonthDays,
        nextMonthDays,
        previousMonthDates,
        currentMonthDates,
        nextMonthDates
      }

      return result
    },

    //
    // UNDO
    //

    handleKeydown (event)
    {
      if (event.keyCode === 90 && event.ctrlKey && this.$store.state.app.EditScale.ctrl_z.data.length > 0)
      {
        this.undo()
      }
    },

    async undo ()
    {
      if (this.undoLoading) {
        console.log("::: Outro processamento de UNDO em andamento ...")
        return
      }

      this.undoLoading = true

      // --- Desfaz a última alteração no banco
      const request = await apiUndoLastScaleDutiesChange(this.$route.params.groupID, this.$route.params.scaleID)

      // --- Resposta
      this.showMessage(request.title, request.message)

      // --- Apaga da store (VueX) o registro da última alteração
      if (request.httpCode === 200) {
        this.$store.commit('REMOVE_LAST_EDIT_SCALE_CTRL_Z_RECORD')
      }

      this.undoLoading = false
    },

    openClearWeekConfirmModal (week) {
      if (!this.weekHasScale(week)) {
        // [24/01/25] console.log('openClearWeekConfirmModal: A SEMANA NÃO TEM ESCALA')
        return false
      }

      // [24/01/25] console.log('openClearWeekConfirmModal:', week)

      const weekStart = week.value[0].dayFmt
      const weekEnd = week.value[6].dayFmt

      // (não os plantões)

      this.showDialog('Atenção!', `A escala que vai do dia ${weekStart} até ${weekEnd} será apagada. <b>Deseja continuar?</b>`, 'clean-week', week)
    },

    openCloneWeekConfirmModal (week) {
      if (!this.weekHasScale(week)) {
        // [24/01/25] console.log('openCloneWeekConfirmModal: A SEMANA NÃO TEM ESCALA')
        return false
      }

      // [24/01/25] console.log('openCloneWeekConfirmModal:', week)

      const weekStart = week.value[0].dayFmt
      const weekEnd = week.value[6].dayFmt

      // (não os plantões)

      const nextFreeWeek = this.getNextFreeWeek(week)
      // [24/01/25] console.log('::: nextFreeWeek:', nextFreeWeek)

      this.showDialog('Atenção!', `A escala que começa no dia ${weekStart} e termina no dia ${weekEnd} será copiada para a próxima semana livre:<br /><br />Do dia ${nextFreeWeek['0']} até ${nextFreeWeek['6']}<br /><br />Os plantões não serão copiados.<br /><b>Deseja continuar?</b>`, 'clone-week', week)
    },

    openEditWeekConfirmModal (week) {
      if (!this.permissaoEscalaDispararPlantoes) {
        this.showMessage('Atenção!', 'Você não tem permissão para editar os plantões disparados nesta escala.')
        return false
      }

      // [24/01/25] console.log('openEditWeekConfirmModal:', week)

      // Verifica se é um mini disparo
      const weekAnalysis = this.getSelectedMiniWeekAnalysis(week)
      if (weekAnalysis && weekAnalysis.miniReleased && weekAnalysis.miniReleased.type) {
        // É um mini disparo, mostra mensagem específica
        const daysToEdit = []
        const daysToExclude = []

        week.value.forEach(day => {
          const dayFmt = day.day.format('DD/MM')
          const dayMonth = day.day.get('month')
          const dayYear = day.day.get('year')
          const currentMonth = this.actualMonth
          const currentYear = this.actualYear

          let shouldExclude = false
          switch (weekAnalysis.miniReleased.type) {
            case 'previous':
              // Edita apenas os dias do mês anterior
              shouldExclude = (dayYear > currentYear || (dayYear === currentYear && dayMonth >= currentMonth))
              break
            case 'current':
              // Edita apenas os dias do mês atual
              shouldExclude = !(dayYear === currentYear && dayMonth === currentMonth)
              break
            case 'next':
              // Edita apenas os dias do mês seguinte
              shouldExclude = (dayYear < currentYear || (dayYear === currentYear && dayMonth <= currentMonth))
              break
          }

          if (shouldExclude) {
            daysToExclude.push(dayFmt)
          } else {
            daysToEdit.push(dayFmt)
          }
        })

        let message = ''
        if (daysToEdit.length > 0) {
          // Formata a mensagem para mostrar o primeiro e último dia do período
          const firstDay = daysToEdit[0]
          const lastDay = daysToEdit[daysToEdit.length - 1]

          if (firstDay === lastDay) {
            message += `Os plantões do dia ${firstDay} serão apagados e os plantonistas vão perder os seus plantões.`
          } else {
            message += `Os plantões dos dias ${firstDay} a ${lastDay} serão apagados e os plantonistas vão perder os seus plantões.`
          }
        }

        message += '<br><br><b>Deseja continuar?</b>'

        this.showDialog('Atenção!', message, 'edit-week', week)
      } else {
        // Não é mini disparo, mostra mensagem padrão
        const weekStart = week.value[0].dayFmt
        const weekEnd = week.value[6].dayFmt

        this.showDialog('Atenção!', `Os plantões dessa semana (Do dia ${weekStart} até ${weekEnd}) serão apagados e os plantonistas vão perder os seus plantões. <b>Deseja continuar?</b>`, 'edit-week', week)
      }
    },

    async cdAction (cdResponse) {
      // [24/01/25] console.log('cdAction:', cdResponse)

      if (cdResponse === false) return

      const $this = this

      var authUser = apiGetCurrentUser()
      var authUserID = authUser.uid

      /**
       *
       * Limpar semana
       *
       */

      if (cdResponse.cdType === 'clean-week') {
        const weekData = cdResponse.cdData

        const update = {}
        const pathsToRemove = []

        weekData.value.map(date => {
          var weekDay = date.dayFmtWzero

          if ($this.scaleTurns.length > 0) {
            $this.scaleTurns.forEach(turn => {
              if (turn.plantoes && turn.plantoes[weekDay]) {
                const path = `escalas/${$this.localGroupID}/${$this.localScaleID}/turnos/${turn.turnID}/plantoes/${weekDay}`
                update[path] = null
                pathsToRemove.push(path)
              }
            })
          }
        })

        // [24/01/25] console.log('::: CLEAN-WEEK:', update, pathsToRemove)

        if (pathsToRemove.length === 0) {
          this.showDialog('Atenção!', '<div style="text-align: center">Não foi possível limpar a semana, pois ela já está vazia.</div>', 'response', false, true, 'center')
        } else {
          const response = await fbFullUpdate(update)

          //
          // Nota do Fernando em 18/Mar/2026:
          //
          // Testei o botão "DESFAZER" e ele emitiu esse warning no inspetor do Chrome:
          // "[2026-03-17T07:50:34.267Z]  @firebase/database: FIREBASE WARNING: update at / failed: permission_denied"
          //
          // Como não entendo o comportamento esperado nesse UNDO mais novo (implementado pela equipe) então recomendo
          // manter ele desativado AQUI até entendermos como ele deve se comportar.
          //
          // Não limpamos tudo via this.$store.commit('CLEAR_EDIT_SCALE_CTRL_Z'), pois isso pode apagar registros de outras
          // semanas que ainda deverão ser manipulados pela feature de UNDO.
          //
          // Depois ver a possibilidade de fazer o mesmo que anotou no comentário do ConfirmScaleModal.vue:
          // >>> O ideal é que no futuro limpe do CTRL+Z apenas os nós relacionados a SEMANA, nesse caso, LIMPA.
          //

          /* $this.$store.commit('SET_EDIT_SCALE_CTRL_Z', { type: 'removemany', data: pathsToRemove }) */

          this.showDialog(response.code === 0 ? 'Atenção!' : 'Feito!', '<div style="text-align: center">' + (response.code === 0 ? 'Não foi possível limpar a semana. Por favor, tente novamente ou fale com nosso suporte.' : 'A semana foi limpa com sucesso.') + '</div>', 'response', false, true, 'center')
        }
      }

      /**
       *
       * Clonar escala (para a próxima semana)
       *
       */

      if (cdResponse.cdType === 'clone-week') {
        const weekData = cdResponse.cdData

        // const fullUpdate = this.buildDuplicatedWeek(weekData, 1)
        let fullUpdate = {}
        let code = 0
        let response

        /* // */
        let numberWeeksAhead = 0

        do {
          // Duplicar o setup da semana atual para a próxima, se houver dias disponíveis
          numberWeeksAhead++

          const obj = this.buildDuplicatedWeek(weekData, numberWeeksAhead)
          code = obj.code
          response = obj.response

          if (code === 1) {
            fullUpdate = response
          }
        } while (Object.keys(fullUpdate).length === 0)
        /* // */

        // fullUpdate = this.buildDuplicatedWeek(weekData.week, weekData.numberWeeksAhead)

        const updatesCount = code === 1 ? Object.keys(fullUpdate).length : 0

        // weekData.firstDayOfWeek

        if (code === 0) {
          // [24/01/25] console.log('::: CLONAR SEMANA [ERRO]:', weekData, fullUpdate, updatesCount)

          if (response === 'conflict') {
            this.showDialog('Atenção!', 'Desculpe, não foi possível copiar a escala, pois a próxima semana não está limpa.', 'response', false, true)
          } else if (response === 'empty') {
            this.showDialog('Atenção!', 'Não foi possível copiar a semana, pois ela está vazia.', 'response', false, true)
          }
        } else {
          // [24/01/25] console.log('::: CLONAR SEMANA:', weekData, fullUpdate, updatesCount)

          const response = await fbFullUpdate(fullUpdate)

          this.showDialog(response.code === 0 ? 'Atenção!' : 'Feito!', '<div style="text-align: center">' + (response.code === 0 ? 'Não foi possível duplicar a semana. Por favor, tente novamente ou fale com nosso suporte.' : 'A semana foi duplicada com sucesso') + '</div>', 'response', false, true, 'center')
        }
      }

      /**
       *
       * Apagar usuário de uma semana já disparada
       *
       */

      if (cdResponse.cdType === 'remove-confirmed-user')
      {
        const { turnID, day, turnUserID, turnUserIndex, week } = cdResponse.cdData

        // [24/01/25] console.log('::: RETIRAR USUÁRIO DO DIA')

        const date = day.dayFmtWzero

        //
        // BASE

        const path = 'escalas/' + this.localGroupID + '/' + this.localScaleID + '/turnos/' + turnID + '/plantoes/' + date

        //
        //

        const turn = this.scaleTurns.length > 0 ? this.scaleTurns.find(scaleTurn => scaleTurn.turnID === turnID) : false

        // [24/01/25] console.log('::: remove-confirmed-user:', turn, turnUserIndex)

        const turnDutyDate = !!turn === true && !!turn.plantoes[date] === true ? turn.plantoes[date] : false
        // const isTurnDutyAvailable = turnDutyDate && !!turnDutyDate.users === true && !!turnDutyDate.users[turnUserID] === true && !!turnDutyDate.users[turnUserID].availableTurn === true
        const plantoesIDs = turnDutyDate && !!turnDutyDate.plantoesIDs === true ? Object.keys(turnDutyDate.plantoesIDs) : false

        // Entries apagados (_deletedFromAcompanhar) não têm plantoesID correspondente.
        // Calcula o índice efetivo contando apenas entries não-apagados antes do alvo.
        const _usersEntries = turnDutyDate?.users ? Object.entries(turnDutyDate.users) : []
        let effectiveIndex = 0
        for (const [key, entry] of _usersEntries) {
          if (key === turnUserID) break
          if (!entry._deletedFromAcompanhar) effectiveIndex++
        }
        const turnDutyID = plantoesIDs && plantoesIDs[effectiveIndex] ? plantoesIDs[effectiveIndex] : false

        //
        //

        if (turnDutyID !== false) {
          let fullUpdate = {}

          // fullUpdate[path + '/confirmedDutys'] = true

          // APAGA O PLANTÃO
          fullUpdate['plantoes/' + turnDutyID] = null

          // APAGA O LOG DO PLANTÃO
          fullUpdate['logs/plantoes/' + turnDutyID] = null

          /*
          // APAGA O PLANTÃO DO TURNO (EDITOR DE ESCALA)
          fullUpdate[path + '/plantoesIDs/' + turnDutyID] = null
          // vue.runtime.esm.js?2b0e:619 [Vue warn]: Error in v-on handler (Promise/async): "Error: Reference.update failed: First argument contains a path /escalas/-Mui-rUCEzvwjGL-1wbo/-MuiDPLk8vpuGztHGUEU/turnos/-MuiDVQUTEHLREwp1Zr9/plantoes/2021-12-29/plantoesIDs that is ancestor of another path /escalas/-Mui-rUCEzvwjGL-1wbo/-MuiDPLk8vpuGztHGUEU/turnos/-MuiDVQUTEHLREwp1Zr9/plantoes/2021-12-29/plantoesIDs/-MumhmTKGimgl3goJAz-"
          */

          // Sinaliza o card como apagado — mantém visível no Criar Escala com estado "Apagado"
          const _userEntry = turn && turn.plantoes?.[date]?.users?.[turnUserID]
          const _assignedUserName = (_userEntry && _userEntry.nome) || null
          const _deletedByName = authUser.displayName || 'Gestor'
          fullUpdate[path + '/users/' + turnUserID + '/_deletedFromAcompanhar'] = {
            deletedBy: authUserID,
            deletedByName: _deletedByName,
            deletedAt: apiServerTimestamp(),
            assignedUserName: _assignedUserName,
          }

          // Entrada de log atômica — lê ponto antes de apagar para preservar dados de check-in/out
          const _dutyData = await getDutyById(turnDutyID)
          const [_y, _m] = date.split('-')
          const _yyyyMM = `${_y}-${_m.padStart(2, '0')}`
          const _logBasePath = `logs/escalas_deleted_log/${this.localGroupID}/${this.localScaleID}/${_yyyyMM}`
          const _logKey = apiGenerateEntityID(_logBasePath)
          fullUpdate[`${_logBasePath}/${_logKey}`] = {
            dateKey: date,
            turnID,
            turnHour: valueToTime(turn.hour),
            endTime: calculateEndTime(valueToTime(turn.hour), formatDbTime(turn.duration)),
            plantonistaNome: _assignedUserName || '',
            valor: (_userEntry && typeof _userEntry.valor === 'number') ? _userEntry.valor : 0,
            deletedByName: _deletedByName,
            deletedBy: authUserID,
            deletedAt: apiServerTimestamp(),
            ...extractPontoForLog(_dutyData),
          }

          // APAGA O PLANTÃO DO GRUPO
          fullUpdate['grupos/' + this.localGroupID + '/plantoes/' + turnDutyID] = null

          // ATUALIZA O TIMESTAMP DO GRUPO PARA PROVOCAR UM RECARREGAMENTO DOS DADOS
          fullUpdate['grupos/' + this.localGroupID + '/data_atual'] = Date.now() // FIX data_atual: número (ms), não ServerValue (sentinel .sv corrompia -> sumia no app)

          //
          // ---------------------------------------------------------------
          // APAGA MENSAGENS RELACIONADAS AO PLANTÃO
          // ---------------------------------------------------------------
          //

          // if (isTurnDutyAvailable) {

          let dutyMessages = await apiGetGroupDutyChatMessages(this.localGroupID, turnDutyID)
          dutyMessages = dutyMessages !== false ? Object.keys(dutyMessages) : []

          if (dutyMessages.length > 0) {
            dutyMessages.forEach(messageID => {
              fullUpdate['chats/' + this.localGroupID + '/chats/' + messageID] = null
            })
          }

          // ---------------------------------------------------------------
          //

          //
          // SE ESTIVER APAGANDO O ÚLTIMO PLANTÃO, LIBERA A SEMANA NOVAMENTE

          /* if (this.weekWasReleaseAndHasOneDuty(week)) {
            fullUpdate[path + '/plantoesIDs'] = null
            fullUpdate[path + '/confirmedDutys'] = null
          } */

          const openWeek = {}
          const weekSetup = week.value

          // Primeiro verifica se há dias disponíveis na semana
          let semanaDisparada = false
          let dutiesCount = 0

          if (this.scaleTurns.length > 0)
          {
            // Depois verifica se plantões já foram disparados na semana
            weekSetup.map((d) => {
              var weekDate = d.dayFmtWzero

              this.scaleTurns.map(turn => {
                if (turn.plantoes) {
                  if (turn.plantoes[weekDate] && turn.plantoes[weekDate].confirmedDutys === true) {
                    semanaDisparada = true
                    openWeek['escalas/' + $this.localGroupID + '/' + $this.localScaleID + '/turnos/' + turn.turnID + '/plantoes/' + weekDate + '/plantoesIDs'] = null
                    openWeek['escalas/' + $this.localGroupID + '/' + $this.localScaleID + '/turnos/' + turn.turnID + '/plantoes/' + weekDate + '/confirmedDutys'] = null
                    openWeek['escalas/' + $this.localGroupID + '/' + $this.localScaleID + '/turnos/' + turn.turnID + '/plantoes/' + weekDate + '/miniReleased'] = null
                  }

                  if (turn.plantoes[weekDate] && turn.plantoes[weekDate].users) {
                    const soma = Object.keys(turn.plantoes[weekDate].users).length
                    if (soma > 0) {
                      dutiesCount += soma
                    }
                  }
                };
              })
            })
          }

          if (semanaDisparada === true && dutiesCount === 1)
          {
            //
            // MARCA A MENSAGEM DE NOVA SEMANA (NO CHAT) PARA SER APAGADA
            //
            // *** JESUS ESTÁ VIVO ***
            //

            const newWeekChatMessages = await apiGetGroupNewWeekChatMessages($this.localGroupID, week.firstDayOfWeek)

            // console.log('apiGetGroupNewWeekChatMessages:', $this.localGroupID, week.firstDayOfWeek, newWeekChatMessages)

            if (newWeekChatMessages !== false) {
              Object.keys(newWeekChatMessages).map(messageKey => {
                fullUpdate['chats/' + $this.localGroupID + '/chats/' + messageKey] = null
              })
            }

            //
            // NOVA MENSAGEM (+ NOTIFICAÇÃO) PARA O GRUPO:
            // -> A SEMANA FOI APAGADA
            //

            const groupName = $this.group.nome || ''
            const scaleName = $this.scaleName || ''
            const weekStart = week.value[0].dayLabel
            const weekEnd = week.value[week.value.length - 1].dayLabel

            //
            // *** JESUS ESTÁ VIVO ***
            //

            const newChatKey = apiGenerateEntityID(`chats/${$this.localGroupID}/chats`)

            fullUpdate['chats/' + $this.localGroupID + '/chats/' + newChatKey] = {
              push: {
                type: 'edit-week',
              },
              uid: authUserID,
              tipo: 'message',
              // tipo: 'new-group',
              displayName: authUser.displayName,
              mensagem: `Os plantões da semana de ${weekStart} a ${weekEnd} foram apagados do grupo ${groupName} (Escala: ${scaleName}).`,
              timestamp: apiServerTimestamp(),
              data: apiServerTimestamp(),
            }

            //
            // APAGA O ÚLTIMO PLANTÃO E ABRE A SEMANA NOVAMENTE PARA EDIÇÃO

            fullUpdate = {
              ...fullUpdate,
              ...openWeek,
            }
          }
          else
          {
            // APAGA O PLANTÃO DO TURNO (EDITOR DE ESCALA)
            fullUpdate[path + '/plantoesIDs/' + turnDutyID] = null
            // vue.runtime.esm.js?2b0e:619 [Vue warn]: Error in v-on handler (Promise/async): "Error: Reference.update failed: First argument contains a path /escalas/-Mui-rUCEzvwjGL-1wbo/-MuiDPLk8vpuGztHGUEU/turnos/-MuiDVQUTEHLREwp1Zr9/plantoes/2021-12-29/plantoesIDs that is ancestor of another path /escalas/-Mui-rUCEzvwjGL-1wbo/-MuiDPLk8vpuGztHGUEU/turnos/-MuiDVQUTEHLREwp1Zr9/plantoes/2021-12-29/plantoesIDs/-MumhmTKGimgl3goJAz-"
          }

          // return semanaNaoFoiDisparada === false && dutiesCount === 1

          // [24/01/25] console.log('::: remove-confirmed-user:', semanaDisparada, dutiesCount, openWeek, plantoesIDs, fullUpdate)

          await fbFullUpdate(fullUpdate)
          // [24/01/25] const response = await fbFullUpdate(fullUpdate)

          /* if (response.code === 0) {
            // [24/01/25] console.log('::: [remove-confirmed-user] Houve um erro ao desfazer o plantão:', response)
          } else {
            // [24/01/25] console.log('::: [remove-confirmed-user] O plantão foi desfeito')
          } */

        }
      }

      /**
       *
       * Apagar usuário do dia e turno
       *
       */

      if (cdResponse.cdType === 'remove-user')
      {
        const { turnID, day, turnUserID } = cdResponse.cdData
        const { groupID, scaleID } = this.$route.params

        const ASSIGNED_USER_PATH = `escalas/${groupID}/${scaleID}/turnos/${turnID}/plantoes/${day.dayFmtWzero}/users/${turnUserID}`

        const ASSIGNED_USER_REMOVAL_NODES = {
          [ASSIGNED_USER_PATH]: null
        }

        const response = await fbFullUpdate(ASSIGNED_USER_REMOVAL_NODES)

        // console.log('::: User removal attempt => Results:', JSON.stringify(ASSIGNED_USER_REMOVAL_NODES), JSON.stringify(response))

        //
        // Nota do Fernando em 17/Mar/2026:
        //
        // O "PATH_MARKED_TO_UNDO" não estava funcionando, então corrigi e a condicional abaixo foi alcançada.
        //
        // Depois testei o botão "DESFAZER" e ele começou a gerar esse warning no inspetor do Chrome:
        // "[2026-03-17T07:50:34.267Z]  @firebase/database: FIREBASE WARNING: update at / failed: permission_denied"
        //
        // Como não entendo o comportamento esperado nesse UNDO mais novo (implementado pela equipe) então achei
        // mais seguro desativá-lo até entendermos como ele deve se comportar.
        //
        // Tenho receio que ele apague dados do RTDB então recomendo manter comentado.
        //

        // console.log('::: User removal attempt => Ctrl+Z content:', JSON.stringify(this.$store.state.app.EditScale.ctrl_z))

        // VERIFICA SE O PLANTÃO FOI COLOCADO NO CTRL+Z PARA APAGAR ELE
        /* const { data } = this.$store.state.app.EditScale.ctrl_z
        const PATH_MARKED_TO_UNDO = data.length > 0 && data.some(x => x.type === "add" && x.data[ASSIGNED_USER_PATH])

        if (response.code === 1 && PATH_MARKED_TO_UNDO)
        {
          $this.$store.commit('SET_EDIT_SCALE_CTRL_Z', { type: 'remove', data: ASSIGNED_USER_PATH })

          console.log('::: O plantão foi retirado do CTRL+Z:', ASSIGNED_USER_PATH, data)
        } */
      }

      /**
       *
       * DESFAZ OS PLANTÕES QUE FORAM DISPARADOS
       *
       */

      if (cdResponse.cdType === 'edit-week')
      {
        const week = cdResponse.cdData

        // setTimeout(async () => {

        var availableDays = week.value // $this.getAvailableDaysInWeek(week)

        const weekTurns = this.scaleTurns

        const turnDutiesBasePath = 'escalas/' + $this.localGroupID + '/' + $this.localScaleID + '/turnos'

        const fullUpdate = {}

        //
        // PERCORRE OS DIAS DISPONÍVEIS NA SEMANA

        for (var i = 0; i < availableDays.length; i++)
        {
          //
          // DIA DISPONÍVEL

          var availableDay = availableDays[i].dayFmtWzero

          //
          // PERCORRE OS TURNOS DO DIA

          await Promise.all(
            weekTurns.map(async turn => {
              const isTurnValid = !!turn.plantoes === true && !!turn.plantoes[availableDay] === true

              if (isTurnValid)
              {
                //
                // APAGAR AS SEGUINTES INFORMAÇÕES DENTRO DO TURNO E DIA PERCORRIDOS AGORA:
                //
                // -> PLANTÕES
                // -> CONFIRMAÇÃO DE DISPARO
                //
                // NOTA: Confirmação de disparo era para bloquear a edição da semana (não mais)
                //

                fullUpdate[turnDutiesBasePath + '/' + turn.turnID + '/plantoes/' + availableDay + '/plantoesIDs'] = null
                fullUpdate[turnDutiesBasePath + '/' + turn.turnID + '/plantoes/' + availableDay + '/confirmedDutys'] = null
                fullUpdate[turnDutiesBasePath + '/' + turn.turnID + '/plantoes/' + availableDay + '/miniReleased'] = null


                //
                // APAGAR:
                //
                // -> PLANTÕES DO TURNO
                // -> MENSAGENS DO GRUPO QUE ESTÃO RELACIONADAS AOS PLANTÕES DO TURNO
                //

                const turnDutiesKeys = turn.plantoes[availableDay].plantoesIDs ? Object.keys(turn.plantoes[availableDay].plantoesIDs) : []

                if (turnDutiesKeys.length > 0)
                {
                  const _editWeekDutyDataMap = {}

                  await Promise.all(
                    turnDutiesKeys.map(async turnDutyID => {
                      // PLANTÃO
                      fullUpdate['plantoes/' + turnDutyID] = null

                      // LOG DO PLANTÃO
                      fullUpdate['logs/plantoes/' + turnDutyID] = null

                      // Lê dados do plantão para enriquecer o log de exclusão com ponto
                      const _dutySnap = await getDutyById(turnDutyID)
                      if (_dutySnap) _editWeekDutyDataMap[turnDutyID] = _dutySnap

                      //
                      // MENSAGENS DO CHAT
                      //
                      // *** JESUS ESTÁ VIVO ***
                      // *** JESUS ESTÁ VIVO ***
                      // *** JESUS ESTÁ VIVO ***
                      //

                      const dutyChatNotifications = await apiGetGroupDutyChatMessages($this.localGroupID, turnDutyID)

                      if (dutyChatNotifications !== false) {
                        Object.keys(dutyChatNotifications).map(chatMessageKey => {
                          fullUpdate['chats/' + $this.localGroupID + '/chats/' + chatMessageKey] = null
                        })
                      }
                    })
                  )

                  // LOG de exclusão: uma entrada por plantão disparado apagado
                  const _usersMap = turn.plantoes[availableDay]?.users || {}
                  const _deletedByName = authUser.displayName || 'Gestor'
                  const [_ly, _lm] = availableDay.split('-')
                  const _yyyyMM = `${_ly}-${_lm.padStart(2, '0')}`
                  const _logBasePath = `logs/escalas_deleted_log/${$this.localGroupID}/${$this.localScaleID}/${_yyyyMM}`
                  const _turnHour = valueToTime(turn.hour)
                  const _endTime = calculateEndTime(_turnHour, formatDbTime(turn.duration))
                  let _dutyCount = 0
                  Object.values(_usersMap).forEach(userEntry => {
                    if (!userEntry || userEntry._deletedFromAcompanhar) return
                    if (_dutyCount >= turnDutiesKeys.length) return
                    const _editWeekDutyID = turnDutiesKeys[_dutyCount]
                    const _editWeekDutyData = _editWeekDutyDataMap[_editWeekDutyID] || null
                    const _logKey = apiGenerateEntityID(_logBasePath)
                    fullUpdate[`${_logBasePath}/${_logKey}`] = {
                      dateKey: availableDay,
                      turnID: turn.turnID,
                      turnHour: _turnHour,
                      endTime: _endTime,
                      plantonistaNome: (typeof userEntry.nome === 'string') ? userEntry.nome : '',
                      valor: (typeof userEntry.valor === 'number') ? userEntry.valor : 0,
                      deletedByName: _deletedByName,
                      deletedBy: authUserID,
                      deletedAt: apiServerTimestamp(),
                      ...extractPontoForLog(_editWeekDutyData),
                    }
                    _dutyCount++
                  })
                }
              }
            })
          )
        }

        //
        // MARCA A MENSAGEM DE NOVA SEMANA (NO CHAT) PARA SER APAGADA
        //
        // *** JESUS ESTÁ VIVO ***
        //

        const newWeekChatMessages = await apiGetGroupNewWeekChatMessages($this.localGroupID, week.firstDayOfWeek)

        // console.log('apiGetGroupNewWeekChatMessages:', $this.localGroupID, week.firstDayOfWeek, newWeekChatMessages)

        if (newWeekChatMessages !== false) {
          Object.keys(newWeekChatMessages).map(messageKey => {
            fullUpdate['chats/' + $this.localGroupID + '/chats/' + messageKey] = null
          })
        }

        //
        // NOVA MENSAGEM (+ NOTIFICAÇÃO) PARA O GRUPO:
        // -> A SEMANA FOI APAGADA
        //

        const groupName = $this.group.nome || ''
        const scaleName = $this.scaleName || ''
        const weekStart = week.value[0].dayLabel
        const weekEnd = week.value[week.value.length - 1].dayLabel

        //
        // *** JESUS ESTÁ VIVO ***
        //

        const newChatKey = apiGenerateEntityID(`chats/${$this.localGroupID}/chats`)

        fullUpdate['chats/' + $this.localGroupID + '/chats/' + newChatKey] = {
          push: {
            type: 'edit-week',
          },
          uid: authUserID,
          tipo: 'message',
          // tipo: 'new-group',
          displayName: authUser.displayName,
          mensagem: `Os plantões da semana de ${weekStart} a ${weekEnd} foram apagados do grupo ${groupName} (Escala: ${scaleName}).`,
          timestamp: apiServerTimestamp(),
          data: apiServerTimestamp(),
        }

        //
        // ATUALIZA DATA DO GRUPO

        fullUpdate['grupos/' + $this.localGroupID + '/data_atual'] = Date.now() // FIX data_atual: número (ms), não ServerValue (sentinel .sv corrompia -> sumia no app)

        //
        // EXECUTA UPDATES

        // console.log('::: EDITAR SEMANA[fullUpdate]:', fullUpdate)

        const response = await fbFullUpdate(fullUpdate)
        this.selectedMiniWeekAnalysis = {}

        // [24/01/25] console.log('EDITAR SEMANA:', response)

        this.showDialog(response.code === 0 ? 'Atenção!' : 'Feito!', '<div style="text-align: center">' + (response.code === 0 ? 'Não foi possível editar a semana. Por favor, tente novamente ou fale com nosso suporte.' : 'A semana está pronta para edição.') + '</div>', 'response', false, true, 'center')
      }

      /**
       *
       * DISPARAR SEMANA APÓS CONFLITOS
       *
       */

      if (cdResponse.cdType === 'releaseWeek')
      {
        const {
          week,
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          slotType
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        } = cdResponse.cdData

        this.releaseWeekDuties({
          week,
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          slotType,
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
          validateConflicts: "NO",
          // As regras de carga horária já foram validadas (e confirmadas, se warn)
          // na primeira passagem, antes da caixa de conflitos
          validateRules: "NO",
        })
      }

      //
      // Gestor confirmou o disparo mesmo com violações "warn" de regras de carga horária
      //

      if (cdResponse.cdType === 'releaseWeekRules')
      {
        const { week, validateConflicts } = cdResponse.cdData

        this.releaseWeekDuties({
          week,
          validateConflicts,
          validateRules: "NO",
        })
      }
    },

    /* SENHOR JESUS */
    /* DESABILITA FUNÇÃO "DUPLICAR SEMANA" QUANDO ALTERA A JORNADA */

    setJornada (jornada) {
      this.jornada = jornada

      // DESABILITA FUNÇÃO "DUPLICAR SEMANA" QUANDO ALTERA A JORNADA
      // this.weeks = this.weeks.map(week => ({ /* shouldDuplicate: false, */ value: week.value }))

      this.$store.commit('SET_WORKINGDAY', this.jornada)
    },

    async updateScaleInfo () {
      // api Update Scale Info (this.localGroupID, this.localScaleID, this.scaleName, this.scaleLocation, response => {

      await apiUpdateScaleName(this.localGroupID, this.localScaleID, this.scaleName)
      // [24/01/25] const request = await apiUpdateScaleName(this.localGroupID, this.localScaleID, this.scaleName)

      // [24/01/25] console.log('::: apiUpdateScaleName:', request)
    },

    /**
     *
     * ?
     *
     */

    removeUserFromTurn (turnID, day, turnUserID, turnUserIndex, week) {
      const dayFmt = day.dayFmt

      // Verifica se a semana foi disparada completamente OU se o dia específico tem mini disparado
      if (this.isWeekReleased(week) || this.isMiniReleased(day)) {
        this.showDialog('Atenção!', 'A semana já foi disparada. O plantonista e o plantão serão retirados desse dia e turno. <b>Deseja continuar?</b>', 'remove-confirmed-user', { turnID, day, turnUserID, turnUserIndex, week })
      } else {
        this.showDialog('Atenção!', `Tem certeza que deseja remover o usuário do plantão do dia ${dayFmt}?`, 'remove-user', { turnID, day, turnUserID })
      }
    },

    openUserModal (turnID, turn, selectedDate)
    {
      // --- /

      const { jornada, journeyWorkingDays, journeyDaysOff } = this.$store.state.app.EditScale

      if (
        jornada === 'Personalizado' &&
        (
          Number(journeyWorkingDays) <= 0 || Number(journeyWorkingDays) > 31 ||
          Number(journeyDaysOff) <= 0 || Number(journeyDaysOff) > 31
        )
      )
      {
        return this.showMessage('Atenção!', 'Você não terminou de personalizar a jornada!<br/ ><br />Desfaça a personalização ou informe quantos dias seguidos você quer inserir plantões (número de 1 a 31) e quantos dias de descanso.<br /><br />Depois tente incluir um novo plantão.')
      }

      // --- /

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      if (![6, 10, 15, 20, 30, 60].includes(this.scaleConsultationDuration))
      {
        return this.showMessage('Atenção!', 'Defina um tempo de consulta na escala onde o plantão será inserido')
      }
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      // --- /

      // console.log('::: OPEN USER MODAL:', turnID, turn, selectedDate)

      const payload = { turnID, turn, selectedDate }

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      if (this.isWeekReleasedByShiftDate(turn, selectedDate)) {
        this.$refs.consultationTypeModal.open("add-assigned-duty", payload)
      } else {
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */
        this.onConsultationTypeModalClose({
          status: "STRAIGHT",
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          slotType: "FREE",
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
          event: "add-assigned-duty",
          payload
        })
      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      }
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */
    },

    onUserModalClosed({ reason, payload })
    {
      // console.log('[EditScale] AddUserToScaleModal closed:', reason, payload)

      // 🔁 retomar polling SEMPRE
      this.START_SCALE_USER_LIST_POLLING()
    },

    /**
     *
     *
     *
     */

    async releaseWeekDuties ({
      week,
      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      slotType,
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */
      validateConflicts,
      validateRules,
    })
    {
      const CHECK_CONFLICTS = (validateConflicts || "") === "NO" ? false : true
      const CHECK_RULES = (validateRules || "") === "NO" ? false : true

      // Propostas de plantão com dono (montadas no loop abaixo) para validação de
      // regras de carga horária em lote antes de qualquer escrita no banco
      const proposedRuleItems = []

      // console.log('::: RELEASE WEEK DUTIES:', { week, slotType, validateConflicts, CHECK_CONFLICTS })

      /**
       *
       * REGRAS:
       * - Se os turnos da escala não tem valor, avisa (o usuário) que os plantões serão disparados sem valor e pede para criar pelo menos um turno com valor (ou deixa zerado)
       * - Verificar se o valor do turno será usado somente nesse momento da criação dos plantões
       *
       */

      const { localGroupID } = this

      var $this = this

      const sequentialShiftConflictsInterval = !!this.group === true && !!this.group.sequentialShiftConflicts === true && Number(this.group.sequentialShiftConflictsInterval) >= 30 && Number(this.group.sequentialShiftConflictsInterval) <= 180 ? Number(this.group.sequentialShiftConflictsInterval) : false

      //
      //
      //
      // ------------------------------------------------------------------------------------------------
      // CONFLITOS (BEGIN)
      // ------------------------------------------------------------------------------------------------
      //
      //
      //

      //
      //
      // CARREGAR TODOS OS PLANTÕES DO GRUPO DENTRO DO MÊS SELECIONADO
      //
      //

      const firstWeek = this.weeks[0]
      const firstDate = firstWeek.value[0].day

      const lastWeek = this.weeks[this.weeks.length - 1]
      const lastDate = lastWeek.value[6].day

      const plantoesDoUsuario = await apiGetGroupShifts(this.$route.params.groupID, firstDate, lastDate)
      const shiftsKeys = plantoesDoUsuario ? Object.keys(plantoesDoUsuario) : []

      //
      // Filtra pelo scaleName e scaleLocation

      // const isValid = isValidDuty(shift) // && shift.groupID === this.$route.params.groupID

      const duties = shiftsKeys.length > 0 ? shiftsKeys.map(shiftID => {
        const shift = plantoesDoUsuario[shiftID]

        if (!isValidDuty(shift)) return false

        const startDateObject = ((shift.dutyStartDateTZ || '') === '+0000' ? moment.utc(shift.data_inicio) : moment(shift.data_inicio))
        const startDateMessage = startDateObject.format('DD/MM/YYYY')
        const startDate = startDateObject.format('YYYY-M-D')
        const startDateForComparison = startDateObject.format('YYYY-MM-DD')

        const startTime = valueToTime(shift.hora_inicio)

        const duration = valueToTime(shift.periodo) // valueToDB

        // [24/01/25] console.log(`endDateTime = calculateEndDateAndTime(${startDate}, ${startTime}, ${duration}, true)`)
        const endDateTime = calculateEndDateAndTime(startDate, startTime, duration, true).split(' ')

        return {
          shiftID,
          scaleID: shift.scaleID,
          ownerID: shift.uid_pegou || 0,
          duration,
          startDate,
          startDateForComparison,
          startDateMessage,
          // SENHOR JESUS está VIVO!!! - o fuso horário pode influenciar?
          startTime,
          // Calcular horário de término do plantão
          endDateWithZero: endDateTime[0],
          endTime: endDateTime[1],
        }
      }).filter(duty => !!duty === true) : []

      // [24/01/25] console.log('::: EDIT SCALE > releaseWeekDuties:', duties.length, duties)

      //
      // JESUS está VIVO !!!
      //
      // escalas com o mesmo nome pode trazer conflito na mensagem?
      //

      const conflicts = []
      // const conflictsScales = []
      // const conflictsUsers = []
      // const conflictsDates = []

      //
      //
      //
      // ------------------------------------------------------------------------------------------------
      // CONFLITOS (END)
      // ------------------------------------------------------------------------------------------------
      //
      //
      //

      //
      //
      //

      // console.log('::: sequentialShiftConflictsInterval:', sequentialShiftConflictsInterval)

      //
      //
      //

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      // const cdur = await apiGetScaleConsultationDuration(localGroupID, localScaleID)

      if (![6, 10, 15, 20, 30, 60].includes(this.scaleConsultationDuration))
      {
        return this.showMessage('Atenção!', 'Defina um tempo de consulta na escala onde o plantão será inserido')
      }

      //
      //
      //

      if (!["FREE", "FIRST_APPOINTMENT", "FOLLOW_UP"].includes(slotType))
      {
        return this.showMessage('Atenção!', 'Defina o tipo de consulta que o plantão vai projetar no Portal Consultas')
      }
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      //
      //
      //

      var diasDaSemana = week.value // this.getAvailableDaysInWeek(week)

      var authUser = apiGetCurrentUser()
      var authUserID = authUser.uid

      let fullUpdate = {}

      const listaDeTurnos = this.scaleTurns

      const dutyLocal = this.scaleLocation.name

      //
      // ex: turno das 7h tem usuários em duas datas (09/07 e 21/07)

      let availableDutiesCount = 0

      /**
       *
       * Percorre os dias da semana a ser disparada
       *
       */

      // Filtrar dias baseado no tipo de disparo mini
      let diasParaDisparar = diasDaSemana

      // Se há selectedMiniWeekAnalysis, filtra os dias baseado no tipo de disparo
      if (this.selectedMiniWeekAnalysis && week.firstDayOfWeek) {
        const weekAnalysis = this.getSelectedMiniWeekAnalysis(week)
        if (weekAnalysis) {
          const { previousMonthDays, currentMonthDays, nextMonthDays, miniReleased } = weekAnalysis

          // Usar o tipo determinado no openSmallDispaModal
          if (miniReleased && miniReleased.type) {
            diasParaDisparar = this.filterDaysByMiniReleasedType(diasDaSemana, miniReleased.type)
          }
        }
      }

      for (var i = 0; i < diasParaDisparar.length; i++)
      {
        const diaDaSemana = diasParaDisparar[i].dayFmtWzero
        const diaDaSemanaParaComparacao = diasParaDisparar[i].dayFmtYmd
        const diaDaSemanaTimestamp = diasParaDisparar[i].dayTimestamp
        const diaDaSemanaParaMensagem = diasParaDisparar[i].dayFmt

        //
        // Percorre todos os turnos do DIA EM PROCESSAMENTO (diasDaSemana > diaDaSemana)
        // Verifica se algum usuário foi adicionado no DIA EM PROCESSAMENTO
        // Sim? Eles serão convertidos em plantões
        //

        // APENAS TURNOS (COM PLANTÕES) NO DIA EM PROCESSAMENTO

        listaDeTurnos.forEach(turn => {
          const diaComUsuarios = !!turn.plantoes === true && !!turn.plantoes[diaDaSemana] === true ? turn.plantoes[diaDaSemana] : false

          // let newDuty

          const turnPlantoesPath = `escalas/${$this.localGroupID}/${$this.localScaleID}/turnos/${turn.turnID}/plantoes/${diaDaSemana}`

          //
          // CONFIRM IF THIS DAY CAN BE FIRED
          // Verifica se é um dia que pode ser disparado

          const turnosDoDia = diaComUsuarios.confirmedDutys !== true && !!diaComUsuarios.users === true && typeof diaComUsuarios.users === 'object'
            ? Object.entries(diaComUsuarios.users).filter(([, u]) => !u._deletedFromAcompanhar)
            : []

          if (turnosDoDia.length > 0)
          {
            const turnoHoraInicio = formatDbTime(turn.hour)
            const turnoDuracao = valueToDB(turn.duration)
            const turnoNome = turn.name || ''
            const turnValue = turn.value || 0

            const turnDurationHHMM = formatDbTime(turn.duration)

            //
            // PROCESS EDIT SCALE USER SHIFTS
            //

            turnosDoDia.map(([_, turnDayDuty]) => {
              if (turnDayDuty._deletedFromAcompanhar) return

              const isUserDuty = !!turnDayDuty.availableTurn === false && !!turnDayDuty.uid === true

              //
              // Calcula o valor do plantão usando a hierarquia de precificação
              //

              let dutyValue = turnValue

              if (isUserDuty && !!dutyValue === false)
              {
                dutyValue = this.calculateAutomaticDutyValue(
                  turnDayDuty.uid,
                  diaDaSemana,
                  turnoHoraInicio,
                  turnDurationHHMM,
                  turnValue
                )
              }

              //
              //
              //

              // const turnoStartDateTime = (new Date(`${diaDaSemana}T${turnoHoraInicio}:00.000Z`)).getTime()

              // console.log(`turnoEndDateTime = calculateEndDateAndTime(${diaDaSemana}, ${turnoHoraInicio}, ${turnDurationHHMM}, true)`)
              // const turnoEndDateTime = calculateEndDateAndTime(diaDaSemana, turnoHoraInicio, turnDurationHHMM, true).split(' ')
              // turnoEndDateTime = (new Date(`${turnoEndDateTime[0]}T${turnoEndDateTime[1]}:00.000Z`)).getTime() // 2024-02-01T00:30:00.000Z

              //
              // Insere plantão disponível ou para usuário específico
              //

              if (!!turnDayDuty.closedTurn === false)
              {
                //
                // Coleta a proposta para a validação de regras de carga horária em lote
                // (somente plantões com dono; plantões disponíveis não contam carga horária)
                //

                if (isUserDuty)
                {
                  proposedRuleItems.push({
                    candidate_id: `${diaDaSemana}|${turn.turnID}|${turnDayDuty.uid}`,
                    user_id: turnDayDuty.uid,
                    scale_id: $this.localScaleID,
                    start_at: buildStartAtISO(diaDaSemanaParaComparacao, turnoHoraInicio),
                    duration_minutes: durationHoursToMinutes(turn.duration),
                  })
                }

                //
                // ------------------------------------------------------------------------------------------------
                // CONFLITOS (BEGIN)
                // ------------------------------------------------------------------------------------------------

                //
                // Jesus VIVE!!!
                //
                // Escala nova é encontrada? Testar uma escala criada por outro gestor entre ENTRAR NA TELA e O DISPARO
                //

                // TEM ALGUM PLANTÃO DISPARADO EM CONFLITO PARA ESSE USUÁRIO, DATA E TURNO EM PROCESSAMENTO NO "EDIT SCALE" ?

                if (isUserDuty)
                {
                  duties.forEach(shift => {
                    if (shift.ownerID === turnDayDuty.uid)
                    {
                      if (
                        checkConflict(
                          { startDate: shift.startDateForComparison, startTime: shift.startTime, duration: shift.duration },
                          { startDate: diaDaSemanaParaComparacao, startTime: turnoHoraInicio, duration: turnDurationHHMM },
                          sequentialShiftConflictsInterval,
                          // turnDayDuty.nome || 'Unknown'
                        )
                      )
                      {
                        const scaleFound = this.listeners.groupScales.find(scale => scale.scaleID === shift.scaleID)
                        const scaleName = !!scaleFound && !!scaleFound.scaleName ? scaleFound.scaleName : shift.scaleID

                        conflicts.push({
                          scaleID: shift.scaleID,
                          scaleName,

                          userID: turnDayDuty.uid,
                          userName: turnDayDuty.nome,

                          turnDate: diaDaSemanaParaMensagem,
                          turnTime: turnoHoraInicio,
                          turnDuration: turnDurationHHMM,

                          shiftDate: shift.startDateMessage,
                          shiftTime: shift.startTime,
                          shiftDuration: shift.duration,
                        })

                        // if (!conflictedScale) conflictsScales.push({ scaleID: existentEditScaleUserShifts.scaleID, scaleName })
                        // if (!conflictedUser) conflictsUsers.push({ scaleID: existentEditScaleUserShifts.scaleID, userID: turnDayDuty.uid, userName: turnDayDuty.nome })
                        // if (!conflictedDate) conflictsDates.push({ scaleID: existentEditScaleUserShifts.scaleID, userID: turnDayDuty.uid, date: diaDaSemanaParaMensagem })
                      }
                    }
                  })
                }

                /* if (existentEditScaleUserShifts.length > 0)
                {
                  const scaleFound = this.listeners.groupScales.find(scale => scale.scaleID === existentEditScaleUserShifts.scaleID)
                  const scaleName = !!scaleFound && !!scaleFound.scaleName ? scaleFound.scaleName : existentEditScaleUserShifts.scaleID

                  const conflictedScale = conflictsScales.some(conflictScale => !!conflictScale.scaleID === true && conflictScale.scaleID === existentEditScaleUserShifts.scaleID)
                  const conflictedUser = conflictsUsers.some(conflictUser => !!conflictUser.scaleID === true && !!conflictUser.userID === true && conflictUser.scaleID === existentEditScaleUserShifts.scaleID && conflictUser.userID === turnDayDuty.uid)
                  const conflictedDate = conflictsDates.some(conflictDate => !!conflictDate.scaleID === true && !!conflictDate.userID === true && !!conflictDate.date === true && conflictDate.scaleID === existentEditScaleUserShifts.scaleID && conflictDate.userID === turnDayDuty.uid && conflictDate.date === diaDaSemanaParaMensagem)

                  if (!conflictedScale) conflictsScales.push({ scaleID: existentEditScaleUserShifts.scaleID, scaleName })
                  if (!conflictedUser) conflictsUsers.push({ scaleID: existentEditScaleUserShifts.scaleID, userID: turnDayDuty.uid, userName: turnDayDuty.nome })
                  if (!conflictedDate) conflictsDates.push({ scaleID: existentEditScaleUserShifts.scaleID, userID: turnDayDuty.uid, date: diaDaSemanaParaMensagem })
                } */

                // ------------------------------------------------------------------------------------------------
                // CONFLITOS (END)
                // ------------------------------------------------------------------------------------------------
                //

                //
                // CRIA A ESTRUTURA DE DADOS DO PLANTÃO
                //

                const dutyData = createDutyObject({
                  /*
                  // [staging-portaltelemedicina / master-portaltelemedicina]
                  slotType,
                  scaleConsultationDuration: this.scaleConsultationDuration,
                  // [staging-portaltelemedicina / master-portaltelemedicina]
                  */

                  dutyGroupID: localGroupID,
                  dutyScaleID: $this.localScaleID,
                  dutyCreatorID: authUserID,
                  dutyOwnerID: turnDayDuty.uid || 0,
                  dutyMessageDate: diaDaSemanaParaMensagem,
                  dataInicioFmt: diaDaSemana,
                  dutyStartDate: diaDaSemanaTimestamp,
                  dutyStartTime: turnoHoraInicio,
                  dutyDuration: turnoDuracao,
                  shiftName: turnoNome,
                  dutyName: $this.scaleName,
                  dutyLocal,
                  dutyValue,

                  // Se o plantão é do tipo DISPONÍVEL, não precisa notificar no chat e via push
                  preventAvailableDutyNotification: isUserDuty === false,

                  isUserDuty,
                  updateGroup: false,
                  turnPath: turnPlantoesPath,
                })

                if (!isUserDuty) {
                  // newDuty.notify = 'no'
                  availableDutiesCount++
                }

                fullUpdate = {
                  ...fullUpdate,
                  ...dutyData,
                }
              }
            })
          }

          //
          // Atualiza o status do plantão dentro do turno, confirmando o disparo e bloqueando para edições
          //

          fullUpdate[turnPlantoesPath + '/confirmedDutys'] = true

          // Determina qual botão mini foi usado baseado no tipo de disparo
          let miniReleasedButton = null
          let miniReleasedType = null

          if (this.selectedMiniWeekAnalysis && week.firstDayOfWeek) {
            const weekAnalysis = this.getSelectedMiniWeekAnalysis(week)
                      if (weekAnalysis && weekAnalysis.miniReleased) {
            miniReleasedType = weekAnalysis.miniReleased.type
            miniReleasedButton = weekAnalysis.miniReleased.button
          }
          }

          if (miniReleasedType && miniReleasedButton) {
            // Mini disparar - marca como disparado e qual botão foi usado
            fullUpdate[turnPlantoesPath + '/miniReleased'] = {
              released: true,
              button: miniReleasedButton,
              type: miniReleasedType
            }
          } else {
            fullUpdate[turnPlantoesPath + '/miniReleased'] = null
          }
        })
      }

      /**
       *
       * O SISTEMA VAI AVISAR O GRUPO QUE A SEMANA DISPARADA TEM PLANTÕES DISPONÍVEIS
       *
       */

      //
      // NOVA MENSAGEM (+ NOTIFICAÇÃO) PARA O GRUPO:
      // -> A SEMANA DISPARADA TEM PLANTÕES DISPONÍVEIS
      //

      if (availableDutiesCount > 0)
      {
        //
        // *** JESUS ESTÁ VIVO ***
        //

        const newChatKeyAvailables = apiGenerateEntityID(`chats/${$this.localGroupID}/chats`)

        const availableDutiesPhrase = availableDutiesCount === 1 ? '1 plantão disponível' : `${availableDutiesCount} plantões disponíveis`

        const groupName = $this.group.nome || ''
        const scaleName = $this.scaleName || ''
        const weekStart = week.value[0].dayLabel
        const weekEnd = week.value[week.value.length - 1].dayLabel

        fullUpdate['chats/' + $this.localGroupID + '/chats/' + newChatKeyAvailables] = {
          referer: week.firstDayOfWeek,

          push: {
            type: 'new-duty',
          },
          uid: authUserID,
          tipo: 'message',
          // tipo: 'new-group',
          displayName: authUser.displayName,
          mensagem: `Tem ${availableDutiesPhrase} na semana de ${weekStart} a ${weekEnd} no grupo ${groupName} (Escala: ${scaleName}).`,
          timestamp: apiServerTimestamp(),
          data: apiServerTimestamp(),
        }
      }

      //
      //
      //
      // ------------------------------------------------------------------------------------------------
      // CONFLITOS (BEGIN)
      // ------------------------------------------------------------------------------------------------
      //
      //
      //

      // ATUALIZA O TIMESTAMP DO GRUPO PARA PROVOCAR UM RECARREGAMENTO DOS DADOS
      fullUpdate['grupos/' + localGroupID + '/data_atual'] = Date.now() // FIX data_atual: número (ms), não ServerValue (sentinel .sv corrompia -> sumia no app)

      //
      //
      // VALIDA AS REGRAS DE CARGA HORÁRIA DO GRUPO (POST /working-hours-rules/validate)
      // ANTES de qualquer escrita: o lote inteiro é validado de uma vez, incluindo
      // descanso mínimo entre as próprias propostas (proposta×proposta).
      // - Violação "block": o disparo é impedido (não há como prosseguir)
      // - Violações apenas "warn": o gestor pode confirmar e disparar mesmo assim
      //
      //

      if (CHECK_RULES && proposedRuleItems.length > 0)
      {
        const ruleValidationResponse = await this.$store.dispatch(VALIDATE_RULES_BATCH, {
          groupId: localGroupID,
          operation: 'batch',
          items: proposedRuleItems,
        })

        const ruleValidationData = (ruleValidationResponse || {}).data || {}
        const ruleViolations = Array.isArray(ruleValidationData.violations) ? ruleValidationData.violations : []

        if (ruleValidationResponse.code === 'OK' && ruleValidationData.violated === true && ruleViolations.length > 0)
        {
          const uniqueViolationMessages = [...new Set(ruleViolations.map(violation => violation.message).filter(Boolean))]

          let violationsHtml = '<table class="tableConflicts">'
          violationsHtml += '<tr><th style="padding: 0 7px">Violação</th></tr>'
          uniqueViolationMessages.forEach(violationMessage => {
            violationsHtml += `<tr><td style="padding: 4px 7px"><span style="color: indianred">${violationMessage}</span></td></tr>`
          })
          violationsHtml += '</table>'

          if (ruleValidationData.can_force_create !== true)
          {
            // Pelo menos uma violação "block": impede o disparo
            this.showMessage('Ação bloqueada', `<div style="text-align: center">Os plantões não podem ser disparados devido a violações de regras de carga horária:<br /><br />${violationsHtml}</div>`)
            return false
          }

          // Apenas violações "warn": pede confirmação do gestor antes de disparar
          this.showConfirmBox({
            title: 'Alerta de violação',
            text: `<div style="text-align: center">Os plantões que você quer disparar têm violações de regras de carga horária:<br /><br />${violationsHtml}<br /><b>Deseja disparar mesmo assim?</b></div>`,
            type: 'releaseWeekRules',
            data: {
              week,
              validateConflicts,
            },
            isResponse: false,
            buttonPosition: 'center',
            width: 720,
            closeText: 'Não',
            continueText: 'Sim',
          })

          return false
        }
      }

      //
      //
      // Mostra conflitos caso algum usuário tenha outro plantão no mesmo horário
      //
      //

      if (CHECK_CONFLICTS && conflicts.length > 0)
      {
        let conflictsTableHtml = '<table class="tableConflicts">'
        conflictsTableHtml += '<tr><th>Membro</th><th>Turno</th><th>Plantão em conflito</th><th>Escala do conflito</th></tr>'

        conflicts.forEach(user => {
          conflictsTableHtml += '<tr style="font-size: 12px">'
          conflictsTableHtml += `<td>${user.userName}</td>`
          conflictsTableHtml += `<td>${user.turnDate} ${user.turnTime} (${user.turnDuration})</td>`
          conflictsTableHtml += `<td>${user.shiftDate} ${user.shiftTime} (${user.shiftDuration})</td>`
          conflictsTableHtml += `<td>${user.scaleName}</td>`
          conflictsTableHtml += '</tr>'
        })

        /* conflictsScales.forEach(scale => {
          conflictsUsers.forEach(user => {
            if (scale.scaleID === user.scaleID) {
              conflictsTableHtml += `<tr><td><b style="color: indianred">${scale.scaleName}</b></td>`
              conflictsTableHtml += `<td><b style="color: indianred">${user.userName}</b></td><td>`

              conflictsDates.forEach(date => {
                if (date.scaleID === scale.scaleID && date.userID === user.userID) {
                  conflictsTableHtml += `${date.date}<br />`
                }
              })

              conflictsTableHtml += '</td>'
            }

            conflictsTableHtml += '</tr>'
          })
        }) */

        conflictsTableHtml += '</table>'

        //
        //
        //

        // const text = `<div style="text-align: center">Algum usuário já tem um plantão no mesmo dia e horário.<br /><br />Veja os conflitos abaixo:<br /><br />${conflictsTableHtml}<br /><b>Deseja disparar a semana mesmo assim?</b></div>`
        const text = `<div style="text-align: center">Algum plantão que você quer disparar está em conflito com outro plantão existente:<br /><br />${conflictsTableHtml}<br /><b>Deseja disparar a semana mesmo assim?</b></div>`

        this.showConfirmBox({
          title: 'Conflito!',
          text,
          type: 'releaseWeek',
          data: {
            week,
            /*
            // [staging-portaltelemedicina / master-portaltelemedicina]
            slotType
            // [staging-portaltelemedicina / master-portaltelemedicina]
            */
          },
          isResponse: false,
          buttonPosition: 'center',
          width: 900, // 768, // 480,
          closeText: 'Não',
          continueText: 'Sim',
        })

        return false
      }

      //
      //
      //
      // EXECUTA AS INSERÇÕES NO BANCO
      //
      //
      //

      // console.log(`::: DISPARAR SEMANA[${week.firstDayOfWeek}]:`, fullUpdate)

      //
      // A escrita é feita pelo BACKEND (POST /duties/dispatch), que revalida as
      // regras de carga horária no servidor antes de gravar — o frontend pré-valida
      // acima apenas para UX. force=true somente quando o gestor já confirmou as
      // violações "warn" nesta tela (validateRules === "NO").
      //

      const dispatchResponse = await this.$store.dispatch(DISPATCH_DUTIES, {
        groupId: localGroupID,
        updates: fullUpdate,
        force: !CHECK_RULES,
      })

      if (dispatchResponse.code === 'OK') {
        this.showMessage('Feito!', '<div style="text-align: center">Os plantões foram criados com sucesso!</div>')
      } else if (dispatchResponse.code === 'RULE_VIOLATION') {
        const dispatchViolations = ((dispatchResponse.data || {}).violations || [])
        const dispatchViolationMessages = [...new Set(dispatchViolations.map(violation => violation.message).filter(Boolean))].join('<br /><br />')

        this.showMessage('Ação bloqueada', `<div style="text-align: center">Os plantões não podem ser disparados devido a violações de regras de carga horária:<br /><br />${dispatchViolationMessages || dispatchResponse.message}</div>`)
      } else {
        this.showMessage('Atenção!', `<div style="text-align: center">${dispatchResponse.message || 'Não foi possível criar plantões. Por favor, tente novamente ou fale com nosso suporte.'}</div>`)
      }
    },

    /**
     *
     * ?
     *
     */

    getDutyImage (scaleUser, day) {
      if (scaleUser && scaleUser.userName && !scaleUser.availableTurn) {
        var userFound = (scaleUser.userID && this.groupUsers) ? this.groupUsers.filter(user => {
          return user.userID === scaleUser.userID
        }) : false

        const userPicture = (!!userFound === true && !!userFound[0] === true && !!userFound[0].userImage === true) ? userFound[0].userImage : '/images/user-profile-broken.png' // userProfileBroken

        return userPicture
      } else if (scaleUser.availableTurn && !scaleUser.closedTurn) {
        return /* this.isExpiredDay(day) */ day.isExpired ? '/images/duty-status-cancelado.png' : '/images/duty-status-available.png'
      } else {
        return '/images/duty-status-cancelado.png'
      }
    },

    /**
     *
     * ?
     *
     */

    getTurnsByDay (day, period)
    {
      if (!day || !day.day || this.scaleTurns.length === 0) return []

      const { dayOfWeek, dayFmtWzero: date } = day

      const turnsByDay = this.scaleTurns.map(turn => {
        // console.log('turn:', turn)
        const dayTurn = (period === 'morning' && turn.turnStartTime < 17) || (period === 'night' && turn.turnStartTime >= 17)
        if (!dayTurn) return false

        // 0 (dom), 1 (seg), 2, 3, 4, 5 e 6
        const mondayStartedDays = this.startOnMonday === 'yes' ? turn.days.map(t => (t === 0) ? 6 : (t - 1)) : turn.days
        const hasDay = mondayStartedDays.filter(d => d === dayOfWeek)

        if (hasDay.length === 0) return false

        const SHIFT_USERS = Object.entries( ((turn?.plantoes ?? {})?.[date] ?? {})?.users || {} )

        const users = SHIFT_USERS.length > 0 ? SHIFT_USERS.map(([SHIFT_USER_ID, SHIFT_USER]) => {
          const userName = String(SHIFT_USER?.nome || "").trim()
          const userImage = String(SHIFT_USER?.img || "").startsWith('https://') ? SHIFT_USER.img : userProfileBroken

          const IS_AVAILABLE = SHIFT_USER.availableTurn && !SHIFT_USER.closedTurn
          const confirmScaleModalStatus = IS_AVAILABLE ? (day.isExpired ? "expired" : "available") : (day.isExpired ? "assigned_expired" : "assigned")

          return !!SHIFT_USER && typeof SHIFT_USER === "object" ? {
            ...SHIFT_USER,
            turnUserID: SHIFT_USER_ID,
            userID: SHIFT_USER.uid,
            userName,
            userImageIsValid: String(SHIFT_USER?.img || "").startsWith('https://'),
            userImage,

            confirmScaleModalStatus,
            confirmScaleModalLabel: IS_AVAILABLE ? (!day.isExpired ? "Disponível" : "Vencido") : userName,
            confirmScaleModalImage: IS_AVAILABLE ? (!day.isExpired ? "/images/duty-status-available.png" : "/images/duty-status-cancelado.png") : (userImage || "/images/user-profile-broken.png"),
          } : null
        }).filter(turnUser => !!turnUser === true && (this.showDeletedDuties || !turnUser._deletedFromAcompanhar)) : []

        const endTime = calculateEndTime(valueToTime(turn.hour), formatDbTime(turn.duration))

        return { ...turn, turnHour: valueToTime(turn.hour), turnDuration: formatFloatToScaleDuration(turn.duration), users, endTime  }
      }).filter(turnByDay => !!turnByDay === true)

      if (turnsByDay.length > 0) turnsByDay.sort((a, b) => a.turnStartTime - b.turnStartTime)

      // console.log(`[${date}] [${period}] GET TURNS BY DAY:`, dayOfWeek, turnsByDay)

      return turnsByDay
    },

    isDayOutOfScale (day, actualMonth) {
    },

    /**
     *
     * CHECK IF THIS WEEK WAS RELEASED
     *
     */

    isWeekReleased (week) {
      if (this.scaleTurns.length === 0) return false

      if (this.hasMiniReleasedOnWeekNode[week.firstDayOfWeek]) {
        return false
      }

      const has = week.value.some(day => {
        return this.scaleTurns.some(turn => {
          return turn.plantoes && turn.plantoes[day.dayFmtWzero] && turn.plantoes[day.dayFmtWzero].confirmedDutys
        })
      })

      return has
    },

    /*
    // [staging-portaltelemedicina / master-portaltelemedicina]
    isWeekReleasedByShiftDate (shift, selectedDate) {
      return (((shift || {})?.plantoes || {})?.[selectedDate.dayFmtWzero] || {})?.confirmedDutys
    },
    // [staging-portaltelemedicina / master-portaltelemedicina]
    */

    /**
     *
     * CHECK IF A SPECIFIC DAY WAS RELEASED BY MINI DISPATCH
     *
     */

    isMiniReleased(day) {
      if (this.scaleTurns.length === 0) return false

      // Procura por plantões com miniReleased em todas as semanas
      for (let weekIndex = 0; weekIndex < this.weeks.length; weekIndex++) {
        const week = this.weeks[weekIndex]
        if (!week || !week.value) continue

        // Verifica se o dia pertence a esta semana
        const dayBelongsToWeek = week.value.some(weekDay => weekDay.dayFmtWzero === day.dayFmtWzero)
        if (!dayBelongsToWeek) continue

        // Verifica se há plantões com miniReleased nesta semana
        const weekAnalysis = this.getSelectedMiniWeekAnalysis(week)
        if (!weekAnalysis || !weekAnalysis.miniReleased || !weekAnalysis.miniReleased.type) continue

        // Verifica se o dia específico tem plantões com miniReleased
        const dayFmtWzero = day.dayFmtWzero
        return this.scaleTurns.some(turn => {
          const diaComUsuarios = turn.plantoes && turn.plantoes[dayFmtWzero]
          return diaComUsuarios &&
                 diaComUsuarios.confirmedDutys === true &&
                 diaComUsuarios.miniReleased &&
                 diaComUsuarios.miniReleased.released === true
        })
      }

      return false
    },


    /**
     *
     * CHECK IF THIS WEEK HAS DUTIES
     *
     */

    weekHasScale (week, miniReleasedType = null) {
      if (this.scaleTurns.length === 0) return false

      // Filtrar dias baseado no tipo de disparo mini (se especificado)
      const diasParaVerificar = this.filterDaysByMiniReleasedType(week.value, miniReleasedType)

      // Verifica se há plantões nos dias (filtrados ou todos)
      const has = diasParaVerificar.some(day => {
        const weekDay = day.dayFmtWzero
        const innerBool = this.scaleTurns.some(turn => turn.plantoes && turn.plantoes[weekDay])
        return innerBool
      })

      return has
    },

    /**
     *
     *
     *
     */

    getNextFreeWeek (week) {
      var $this = this

      if (this.scaleTurns.length === 0) {
        return false
      }

      let areAnyDayInNextWeek = false
      let numberWeeksAhead = 0
      let nextFreeWeekSundayObj
      let nextFreeWeekMondayObj
      let nextFreeWeekTuesdayObj
      let nextFreeWeekWednesdayObj
      let nextFreeWeekThursdayObj
      let nextFreeWeekFridayObj
      let nextFreeWeekSaturdayObj

      do {
        // próxima semana
        numberWeeksAhead++

        // dias da próxima semana
        nextFreeWeekSundayObj = week.value[0].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekMondayObj = week.value[1].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekTuesdayObj = week.value[2].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekWednesdayObj = week.value[3].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekThursdayObj = week.value[4].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekFridayObj = week.value[5].day.clone().add((7 * numberWeeksAhead), 'days')
        nextFreeWeekSaturdayObj = week.value[6].day.clone().add((7 * numberWeeksAhead), 'days')

        var nextFreeWeekSunday = nextFreeWeekSundayObj.format('YYYY-M-D')
        var nextFreeWeekMonday = nextFreeWeekMondayObj.format('YYYY-M-D')
        var nextFreeWeekTuesday = nextFreeWeekTuesdayObj.format('YYYY-M-D')
        var nextFreeWeekWednesday = nextFreeWeekWednesdayObj.format('YYYY-M-D')
        var nextFreeWeekThursday = nextFreeWeekThursdayObj.format('YYYY-M-D')
        var nextFreeWeekFriday = nextFreeWeekFridayObj.format('YYYY-M-D')
        var nextFreeWeekSaturday = nextFreeWeekSaturdayObj.format('YYYY-M-D')

        // verifica se tem escala montada em algum dia da semana processada
        areAnyDayInNextWeek = $this.scaleTurns.some(turn => {
          // return turn.plantoes && turn.plantoes[formattedSundayOfNextFreeWeek]
          return turn.plantoes && (
            (turn.plantoes[nextFreeWeekSunday] && turn.plantoes[nextFreeWeekSunday].users) ||
            (turn.plantoes[nextFreeWeekMonday] && turn.plantoes[nextFreeWeekMonday].users) ||
            (turn.plantoes[nextFreeWeekTuesday] && turn.plantoes[nextFreeWeekTuesday].users) ||
            (turn.plantoes[nextFreeWeekWednesday] && turn.plantoes[nextFreeWeekWednesday].users) ||
            (turn.plantoes[nextFreeWeekThursday] && turn.plantoes[nextFreeWeekThursday].users) ||
            (turn.plantoes[nextFreeWeekFriday] && turn.plantoes[nextFreeWeekFriday].users) ||
            (turn.plantoes[nextFreeWeekSaturday] && turn.plantoes[nextFreeWeekSaturday].users)
          )
        })
      } while (areAnyDayInNextWeek === true)

      return {
        numberWeeksAhead,
        0: nextFreeWeekSundayObj.format('DD/MM/YYYY'),
        1: nextFreeWeekMondayObj.format('DD/MM/YYYY'),
        2: nextFreeWeekTuesdayObj.format('DD/MM/YYYY'),
        3: nextFreeWeekWednesdayObj.format('DD/MM/YYYY'),
        4: nextFreeWeekThursdayObj.format('DD/MM/YYYY'),
        5: nextFreeWeekFridayObj.format('DD/MM/YYYY'),
        6: nextFreeWeekSaturdayObj.format('DD/MM/YYYY'),
      }
    },

    buildDuplicatedWeek (week, numberWeeksAhead) {
      var $this = this
      let weekOrDayAlreadySet = false
      const update = {}

      week.value.map(date => {
        var formattedDay = date.dayFmtWzero
        var dateOfNextWeek = date.day.clone().add((7 * numberWeeksAhead), 'days')
        // var dateOfNextWeek = this.$moment(date.day).add((7 * numberWeeksAhead), 'days')
        var formattedDayOfNextWeek = dateOfNextWeek.format('YYYY-M-D')

        if ($this.scaleTurns.length > 0) {
          $this.scaleTurns.forEach(turn => {
            if (!weekOrDayAlreadySet) {
              if (turn.plantoes) {
                if (turn.plantoes[formattedDayOfNextWeek] && turn.plantoes[formattedDayOfNextWeek].users) {
                  weekOrDayAlreadySet = true
                } else if (turn.plantoes[formattedDay]) {
                  const plantao = turn.plantoes[formattedDay]
                  const turnUsers = plantao.users || false
                  const turnUsersKeys = turnUsers ? Object.keys(plantao.users) : []

                  // if (plantao.users) {

                  if (turnUsersKeys.length > 0) {
                    turnUsersKeys.forEach(userKey => {
                      const key = apiGenerateEntityID(`escalas/${$this.localGroupID}/${$this.localScaleID}/turnos/${turn.turnID}/plantoes/${formattedDayOfNextWeek}/users`)

                      update['escalas/' + $this.localGroupID + '/' + $this.localScaleID + '/turnos/' + turn.turnID + '/plantoes/' + formattedDayOfNextWeek + '/users/' + key] = turnUsers[userKey]
                    })
                  }
                }
              }
            }
          })
        }
      })

      if (weekOrDayAlreadySet) {
        return {
          code: 0,
          response: 'conflict',
        }
      } else if (Object.keys(update).length === 0) {
        return {
          code: 0,
          response: 'empty',
        }
      }

      return {
        code: 1,
        response: update,
      }
    },

    /**
     *
     * FILTER DAYS BASED ON MINI RELEASED TYPE
     *
     */

    filterDaysByMiniReleasedType(days, miniReleasedType) {
      if (!miniReleasedType) {
        return days
      }

      switch (miniReleasedType) {
        case 'previous':
          // Filtra apenas os dias do mês anterior ao mês atual
          return days.filter(dia => {
            const dayMonth = dia.day.get('month')
            const dayYear = dia.day.get('year')
            return dayYear < this.actualYear || (dayYear === this.actualYear && dayMonth < this.actualMonth)
          })

        case 'current':
          // Filtra apenas os dias do mês atual sendo visualizado
          return days.filter(dia => {
            const dayMonth = dia.day.get('month')
            const dayYear = dia.day.get('year')
            return dayYear === this.actualYear && dayMonth === this.actualMonth
          })

        case 'next':
          // Filtra apenas os dias do mês seguinte ao mês atual
          return days.filter(dia => {
            const dayMonth = dia.day.get('month')
            const dayYear = dia.day.get('year')
            return dayYear > this.actualYear || (dayYear === this.actualYear && dayMonth > this.actualMonth)
          })

        default:
          return days
      }
    },

    /**
     *
     * DETECT MINI RELEASED DUTIES WHEN SCALE LOADS
     *
     */

    detectMiniReleasedDuties() { //
      if (!this.scaleTurns || this.scaleTurns.length === 0) return

      // Objeto para mapear semanas com miniReleased usando firstDayOfWeek como índice
      this.selectedMiniWeekAnalysis = {}

      // Procura por plantões com miniReleased em todas as semanas
      for (let weekIndex = 0; weekIndex < this.weeks.length; weekIndex++) {
        const week = this.weeks[weekIndex]
        if (!week || !week.value) continue

        // Verifica se há algum dia na semana com miniReleased
        const hasMiniReleasedOnWeek = this.hasMiniReleasedOnWeek(week)

        if (hasMiniReleasedOnWeek) {
          // Encontrou uma semana com miniReleased, usa firstDayOfWeek como índice
          const weekKey = week.firstDayOfWeek

          // Inicializa a análise da semana
          this.selectedMiniWeekAnalysis[weekKey] = this.analyzeWeekMonths(week.value)

          // Procura o primeiro dia com miniReleased para determinar o tipo e botão
          for (const day of week.value) {
            const dayFmtWzero = day.dayFmtWzero
            const turnWithMiniReleased = this.scaleTurns.find(turn => {
              const diaComUsuarios = turn.plantoes && turn.plantoes[dayFmtWzero]
              return diaComUsuarios &&
                     diaComUsuarios.confirmedDutys === true &&
                     diaComUsuarios.miniReleased &&
                     diaComUsuarios.miniReleased.released === true
            })

            if (turnWithMiniReleased) {
              const diaComUsuarios = turnWithMiniReleased.plantoes[dayFmtWzero]
              const miniReleased = diaComUsuarios.miniReleased

              // Define o selectedMiniWeekAnalysis com as informações do miniReleased usando o índice da semana
              if (miniReleased && miniReleased.released === true) {
                this.selectedMiniWeekAnalysis[weekKey] = {
                  ...this.selectedMiniWeekAnalysis[weekKey],
                  miniReleased,
                  weekIndex: weekIndex,
                  firstDayOfWeek: weekKey
                }
              }

              // console.log('Detected mini released duties for week:', {
                // weekKey,
                // weekIndex,
                // miniReleased,
                // week: week.firstDayOfWeek
              // })

              break // Encontrou para esta semana, vai para a próxima
            }
          }
        }
      }

      // Verifica se há algum miniReleased análise, se sim a semana foi disparada
      // Inicializa hasMiniReleasedOnWeekNode como objeto vazio
      this.hasMiniReleasedOnWeekNode = {}

      // Para cada semana que tem miniReleased, marca como true no índice correspondente
      Object.keys(this.selectedMiniWeekAnalysis).forEach(weekKey => {
        const weekAnalysis = this.selectedMiniWeekAnalysis[weekKey]
        if (weekAnalysis && weekAnalysis.miniReleased && weekAnalysis.miniReleased.released === true) {
          this.hasMiniReleasedOnWeekNode[weekKey] = true
        }
      })
    },

    /**
     *
     * FILTER DAYS BASED ON MINI RELEASED TYPE
     *
     */

    /**
     *
     * GET SELECTED MINI WEEK ANALYSIS FOR A SPECIFIC WEEK
     *
     */

    getSelectedMiniWeekAnalysis(week) {
      // console.log('getSelectedMiniWeekAnalysis:', week, this.selectedMiniWeekAnalysis)
      if (!week || !week.firstDayOfWeek || !this.selectedMiniWeekAnalysis) {
        return null
      }

      return this.selectedMiniWeekAnalysis[week.firstDayOfWeek] || null
    },

    /**
     *
     * Polling logic for loading and keeping the scale user list up to date.
     *
     * - Uses conditional requests (If-Modified-Since / 304 Not Modified)
     * - Caches successful responses in the browser to avoid blocking the EditScale loader
     * - Immediately serves cached data when available
     * - Continues polling in the background to refresh data when needed
     *
     * This allows the User Assignment modal and EditScale screen
     * to display data instantly while staying synchronized with the server.
     *
     */

    async loadScaleUserList(LOCAL_REQUEST_ID_FOR_DEBUGGING = null)
    {
      const { groupID, scaleID } = this.$route.params

      // Prevent overlapping requests if a previous poll is still running
      if (this.pollingRunning)
      {
        logDebug({
          box: `Usuários da escala "${this.scaleName || this.$route.params.scaleID}"`,
          boxColor: 'white',
          title: `[${LOCAL_REQUEST_ID_FOR_DEBUGGING}] Previous request is still going...`,
          titleColor: 'orangered'
        })

        return
      }

      this.pollingRunning = true

      try
      {
        logDebug({
          box: `Usuários da escala "${this.scaleName || this.$route.params.scaleID}"`,
          boxColor: 'white',
          title: `[${LOCAL_REQUEST_ID_FOR_DEBUGGING}] Checking...`,
          titleColor: 'black'
        })

        // Conditional request using the last known update timestamp
        const response = await apiGetUserListByScale(groupID, scaleID, this.lastUsersUpdateAt || "")

        // No changes since last poll (HTTP 304)
        if (response.httpCode === 304)
        {
          this.pollingRunning = false

          logDebug({
            box: `Usuários da escala "${this.scaleName || scaleID}"`,
            boxColor: 'white', title: `[${LOCAL_REQUEST_ID_FOR_DEBUGGING}] Not modified`,
            titleColor: '#EF6C00',
            message: `Last updated ${this.lastUsersUpdateAt}`
          })

          return
        }

        // Log unexpected responses
        if (response.httpCode !== 200)
        {
          logDebug({
            box: `Usuários da escala "${this.scaleName || this.$route.params.scaleID}"`,
            boxColor: 'white',
            title: `[${LOCAL_REQUEST_ID_FOR_DEBUGGING}] Request failed`,
            titleColor: '#C62828',
            message: JSON.stringify(response, null, 2)
          })
        }

        // Successful response: update memory and browser cache
        if (response.httpCode === 200)
        {
          const LAST_UPDATE_AT = response.response_headers?.['last-modified'] || null

          // this.cachedUsersForScale = response.data
          this.lastUsersUpdateAt = LAST_UPDATE_AT

          // Persist data in browser cache to speed up future loads
          EditScaleUsersCache.set(groupID, scaleID, response.data, LAST_UPDATE_AT)

          logDebug({
            box: `Usuários da escala "${this.scaleName || this.$route.params.scaleID}"`,
            boxColor: 'yellow',
            title: `[${LOCAL_REQUEST_ID_FOR_DEBUGGING}] Updated`,
            titleColor: '#1565C0',
            message: `${response.data.length} users received`,
          })
        }

        this.pollingRunning = false
      }
      finally
      {
        this.pollingRunning = false
      }
    },

    START_SCALE_USER_LIST_POLLING()
    {
      // Avoid starting multiple polling intervals
      if (this.pollingTimer) return

      // Wrapper to keep a stable function reference for setInterval
      const run = () => {
        const LOCAL_REQUEST_ID_FOR_DEBUGGING = Date.now()
        this.loadScaleUserList(LOCAL_REQUEST_ID_FOR_DEBUGGING)
      }

      // Run immediately to avoid waiting for the first interval tick
      run()

      // Start periodic polling
      const FREQUENCY = 5 * 1000
      this.pollingTimer = setInterval(run, FREQUENCY)

      logDebug({
        box: `Usuários da escala "${this.scaleName || this.$route.params.scaleID}"`,
        boxColor: 'white',
        title: 'Polling started.',
        titleColor: '#1565C0'
      })
    },

    STOP_SCALE_USER_LIST_POLLING()
    {
      // Avoid clearing an interval that does not exist
      if (!this.pollingTimer) return

      logDebug({
        box: `Usuários da escala "${this.scaleName || this.$route.params.scaleID}"`,
        boxColor: 'white',
        title: 'Polling stopped.',
        titleColor: '#616161'
      })

      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    },

    /**
     *
     *
     *
     */

    async onConsultationTypeModalClose(args)
    {
      // console.log("::: onConsultationTypeModalClose => args:", args)

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      //
      // --- Tipo de slot & consulta
      //

      if (
        // status !== "CONFIRMED" ||
        !["FREE", "FIRST_APPOINTMENT", "FOLLOW_UP"].includes(args.slotType)
      )
      {
        return this.showMessage('Atenção!', 'Defina o tipo de consulta que o plantão vai projetar no Portal Consultas')
      }
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      if (args.status !== "CONFIRMED" && args.status !== "STRAIGHT")
      {
        return
      }

      //
      // --- Abre modal para "confirmar o disparo da semana" depois que selecionou o "tipo de consulta"
      //

      if (args.event === "confirm-scale")
      {
        this.$refs.csModal.open(/* [staging-portaltelemedicina / master-portaltelemedicina] args.slotType [staging-portaltelemedicina / master-portaltelemedicina] */)
      }

      //
      // --- Adiciona "plantão livre" depois que selecionou o "tipo de consulta"
      //

      else if (args.event === "add-available-duty")
      {
        const { turnID, turn, selectedDate } = args.payload
        const { jornada, journeyWorkingDays, journeyDaysOff } = this.$store.state.app.EditScale

        const weeks = this.weeks.map(week => ({ ...week, isReleasedWeek: this.isMiniOrWeekReleased(week, selectedDate) }))

        const fullUpdate = await createShift({
          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          slotType: args.slotType,
          scaleConsultationDuration: this.scaleConsultationDuration,
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */

          user: { availableTurn: true }, // DISPONÍVEL
          userScaleHourlyRate: 0,
          scaleData: {
            weekdaysHourlyRate: this.scaleWeekdaysHourlyRate,
            weekendHourlyRate: this.scaleWeekendHourlyRate,
            dayShiftHourlyRate: this.scaleDayShiftHourlyRate,
            nightShiftHourlyRate: this.scaleNightShiftHourlyRate,
            weekdaysDayShiftHourlyRate: this.scaleWeekdaysDayShiftHourlyRate,
            weekdaysNightShiftHourlyRate: this.scaleWeekdaysNightShiftHourlyRate,
            weekendDayShiftHourlyRate: this.scaleWeekendDayShiftHourlyRate,
            weekendNightShiftHourlyRate: this.scaleWeekendNightShiftHourlyRate,
            hourlyrate: this.scaleValue,
          },
          jornada,
          journeyWorkingDays,
          journeyDaysOff,
          weeks,
          turnID,
          turnoDados: turn,
          dataSemZero: selectedDate.day.format('YYYY-M-D'),
          groupID: this.$route.params.groupID,
          grupoNome: this.nomeDoGrupo,
          scaleID: this.$route.params.scaleID,
          scaleName: this.scaleName,
          scaleLocation: this.scaleLocation,
        })

        // this.loading = true
        const response = await fbFullUpdate(fullUpdate.firebasePaths)
        // this.loading = false

        // console.log('::: ADD_AVAILABLE_DUTY => UPDATE:', fullUpdate, response)

        if (response.code === 1) {
          this.$store.commit('SET_EDIT_SCALE_CTRL_Z', { type: 'add', data: fullUpdate.firebasePaths })
        }
      }

      //
      // --- Abre seletor de usuários para adicionar "plantão com plantonista" depois que selecionou o "tipo de consulta"
      //

      else if (args.event === "add-assigned-duty")
      {
        const { turnID, turn, selectedDate } = args.payload

        // --- O modal ainda não pode abrir, pois o endpoint ainda está processando ou falhou;

        // 🔹 só bloqueia se NÃO houver cache
        // if (!this.cachedUsersForScale || this.cachedUsersForScale.length === 0) {
        //   return this.showMessage('Atenção!', 'Os plantonistas desta escala ainda estão sendo carregados. Aguarde alguns instantes e tente novamente.')
        // }

        // --- Pausa o polling até fechar o modal
        this.STOP_SCALE_USER_LIST_POLLING()

        // --- Abre o modal
        this.$refs.userModal.open({
          // PROVISÓRIO / FOR NOW
          // rawUsers: this.cachedUsersForScale,

          scaleID: this.$route.params.scaleID,
          scaleName: this.scaleName,
          scaleLocation: this.scaleLocation,
          scaleTurns: this.scaleTurns,
          // escala: this.localScaleID,

          groupID: this.localGroupID,
          grupoNome: this.nomeDoGrupo,

          turnID,
          turnoDados: turn,

          date: selectedDate,

          // [09/01/25] Solução paliativa para ler o VALOR HORA DO USUÁRIO NA ESCALA (se houver)
          scaleUsers: this.scaleUsers,

          // Valores de precificação da escala
          scaleValue: this.scaleValue,
          scaleWeekdaysHourlyRate: this.scaleWeekdaysHourlyRate,
          scaleWeekendHourlyRate: this.scaleWeekendHourlyRate,
          scaleDayShiftHourlyRate: this.scaleDayShiftHourlyRate,
          scaleNightShiftHourlyRate: this.scaleNightShiftHourlyRate,
          scaleWeekdaysDayShiftHourlyRate: this.scaleWeekdaysDayShiftHourlyRate,
          scaleWeekdaysNightShiftHourlyRate: this.scaleWeekdaysNightShiftHourlyRate,
          scaleWeekendDayShiftHourlyRate: this.scaleWeekendDayShiftHourlyRate,
          scaleWeekendNightShiftHourlyRate: this.scaleWeekendNightShiftHourlyRate,

          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          scaleConsultationDuration: this.scaleConsultationDuration,
          slotType: args.slotType,
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        })
      }
    },
  },
}
